webpackJsonp([1],{

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
const defaultConfig = {
  width: "100%",
  height: 600,
  path: './editor.md/lib/',
  toolbarIcons: function () {
    //["undo", "redo", "|", "bold", "del", "italic", "quote", "ucwords", "uppercase", "lowercase", "|", "h1", "h2", "h3", "h4", "h5", "h6", "|", "list-ul", "list-ol", "hr", "|", "link", "reference-link", "image", "code", "preformatted-text", "code-block", "table", "datetime", "emoji", "html-entities", "pagebreak", "|", "goto-line", "watch", "preview", "fullscreen", "clear", "search", "|", "help", "info"]
    return ["bold", "del", "italic", "quote", "ucwords", "uppercase", "lowercase", "|",
      "h1", "h2", "h3", "h4", "h5", "h6", "|",
      "hr", "code", "preformatted-text", "code-block", "table", "pagebreak", "|",
      "goto-line", "preview", "clear"]
  },
  // theme: 'dark',
  // previewTheme: 'dark',
  // editorTheme: 'pastel-on-dark',
  markdown: '',      // 默认填充内容
  lineWrapping: true, // 编辑框不换行
  codeFold: true,                 // 代码折叠
  placeholder: '请输入...',
  syncScrolling: true,
  saveHTMLToTextarea: true,       // 保存 HTML 到 Textarea
  searchReplace: true,
  watch: true,                                // 实时预览
  htmlDecode: "style,script,iframe",      // 开启 HTML 标签解析，为了安全性，默认不开启
  toolbar: true,                  //工具栏
  previewCodeHighlight: true,     // 预览 HTML 的代码块高亮，默认开启
  emoji: true,
  taskList: true,
  tocm: true,                     // Using [TOCM]
  tex: true,                      // 开启科学公式TeX语言支持，默认关闭
  flowChart: true,                // 开启流程图支持，默认关闭
  sequenceDiagram: true,          // 开启时序/序列图支持，默认关闭,
  // dialogLockScreen: false,      // 设置弹出层对话框不锁屏，全局通用，默认为true
  // dialogShowMask: false,        // 设置弹出层对话框显示透明遮罩层，全局通用，默认为true
  // dialogDraggable: false,       // 设置弹出层对话框不可拖动，全局通用，默认为true
  // dialogMaskOpacity: 0.4,       // 设置透明遮罩层的透明度，全局通用，默认值为0.1
  // dialogMaskBgColor: "#000",    // 设置透明遮罩层的背景颜色，全局通用，默认为#fff
  // imageUpload: false,
  // imageFormats: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'webp'],
  // imageUploadURL: "/fs/fs/file/upload",
  // onload: function() {
  //    // this.fullscreen();
  //    // this.unwatch();
  //    // this.watch().fullscreen();
  //    // this.setMarkdown("#PHP");
  //    // this.width("100%");
  //    // this.height(480);
  //    // this.resize("100%", 640);
  // },
};



/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web_signup__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web_signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__web_signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__web_404__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__web_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__web_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__web_find_password__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__web_find_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__web_find_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__web_doc_component__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__web_doc_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__web_doc_search__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__web_doc_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__web_doc_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tw_doc__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tw_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_tw_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__web_doc_document_menu__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__web_doc_document_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__web_doc_document_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__web_style__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__web_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__web_style__);







// // 中心相关路由
 // 公共页面
 // 查询页面

// import twIntroduceLeft from '@/web/doc/introduce-left'
// import twDesignLeft from '@/web/doc/design-left'
// import twEcrLeft from '@/web/doc/ecr-left'

// import twIntegrateQuick from '@/web/doc/integrate-quick'
// import twIntegrateFrame from '@/web/doc/integrate-frame'
// import twIntegrateApi from '@/web/doc/integrate-api'
// import twIntegrateFaq from '@/web/doc/integrate-faq'
// import twIntegrate from '@/web/doc/integrate-top' // 应用集成页
// import twManualBook from '@/web/doc/integrate-manualbook' // 操作手册页
// import twManualBookFaq from '@/web/doc/manualbook-faq' // 操作手册-FAQ
// import twXtbgFrame from '@/web/doc/xtbg-frame' // 协同办公
// import twWjdcFrame from '@/web/doc/wjdc-frame' // 问卷调查

// 以下为临时的样式页路由，发布版本中请删除


// import utils from '@/config/cookieUtils'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_7__components_tw_doc___default.a,
    name: 'Doc'
  },
  // {
  //   path: '/introduce',
  //   component: twIntroduceLeft,
  //   redirect: '/introduce/scene',
  //   children: [
  //     {
  //       path: '/introduce/scene',
  //       name: 'TWPAAS1200000000000',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/introduce/overview',
  //       name: 'TWPAAS1200000000001',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/introduce/noun',
  //       name: 'TWPAAS1200000000002',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/introduce/log',
  //       name: 'TWPAAS1200000000003',
  //       component: twDocComponent
  //     }
  //   ]
  // },
  // {
  //   path: '/manualbook',
  //   component: twManualBook,
  //   redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/manualbook/faq/login' : '/manualbook/faq/login',
  //   children: [
  //     {
  //       path: 'faq',
  //       component: twManualBookFaq,
  //       redirect: '/manualbook/faq/login',
  //       children: [
  //         {
  //           path: '/manualbook/faq/login',
  //           name: 'TWMBOOK1200000000001',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/faq/findpwd',
  //           name: 'TWMBOOK1200000000002',
  //           component: twDocComponent
  //         }
  //       ]
  //     },
  //     // 问卷调查
  //     {
  //       path: 'wjdc',
  //       component: twWjdcFrame,
  //       redirect: '/manualbook/wjdc/wjcjwj',
  //       children: [
  //         {
  //           path: '/manualbook/wjdc/wjcjwj',
  //           name: 'TWMBOOK1400000000001',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjsjwj',
  //           name: 'TWMBOOK1400000000002',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjsz',
  //           name: 'TWMBOOK1400000000003',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjwgsz',
  //           name: 'TWMBOOK1400000000004',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/fbwj',
  //           name: 'TWMBOOK1400000000005',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjhswj',
  //           name: 'TWMBOOK1400000000006',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjfxxz',
  //           name: 'TWMBOOK1400000000007',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/tjfxxz',
  //           name: 'TWMBOOK1400000000008',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/ckxzdj',
  //           name: 'TWMBOOK1400000000009',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjfz',
  //           name: 'TWMBOOK1400000000010',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjsc',
  //           name: 'TWMBOOK1400000000011',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/wjdc/wjzx',
  //           name: 'TWMBOOK1400000000012',
  //           component: twDocComponent
  //         }
  //       ]
  //     },
  //     // 协同办公
  //     {
  //       path: 'xtbg',
  //       component: twXtbgFrame,
  //       redirect: '/manualbook/xtbg/login',
  //       children: [
  //         {
  //           path: '/manualbook/xtbg/login',
  //           name: 'TWMBOOK1300000000001',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/zyjs',
  //           name: 'TWMBOOK1300000000002',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/czwdxz',
  //           name: 'TWMBOOK1330000000002',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/dzgrzy',
  //           name: 'TWMBOOK1300000000003',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/glbmyhxx',
  //           name: 'TWMBOOK1300000000004',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/kqgzsz',
  //           name: 'TWMBOOK1300000000005',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/lcfqxj',
  //           name: 'TWMBOOK1300000000006',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/wddb',
  //           name: 'TWMBOOK1300000000007',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/jbgz',
  //           name: 'TWMBOOK1300000000008',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/lscx',
  //           name: 'TWMBOOK1300000000009',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/xzbg',
  //           name: 'TWMBOOK1300000000010',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/grrwzy',
  //           name: 'TWMBOOK1300000000011',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/rwxm',
  //           name: 'TWMBOOK1300000000012',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/rwdt',
  //           name: 'TWMBOOK1300000000013',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/cjwj',
  //           name: 'TWMBOOK1300000000014',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/hswj',
  //           name: 'TWMBOOK1300000000015',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/wjcx',
  //           name: 'TWMBOOK1300000000016',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/ckwjdt',
  //           name: 'TWMBOOK1300000000017',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/txwj',
  //           name: 'TWMBOOK1300000000018',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/kmgnjs',
  //           name: 'TWMBOOK1300000000019',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/kmqxqb',
  //           name: 'TWMBOOK1300000000020',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/kmdlfs',
  //           name: 'TWMBOOK1300000000021',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/kmsy',
  //           name: 'TWMBOOK1300000000022',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/kmgrwp',
  //           name: 'TWMBOOK1300000000023',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/kmggwp',
  //           name: 'TWMBOOK1300000000024',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/xxrk',
  //           name: 'TWMBOOK1300000000025',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/xtxx',
  //           name: 'TWMBOOK1300000000026',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/yhxx',
  //           name: 'TWMBOOK1300000000027',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/manualbook/xtbg/xxgg',
  //           name: 'TWMBOOK1300000000028',
  //           component: twDocComponent
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/integrate',
  //   component: twIntegrate,
  //   redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/quick/account' : '/integrate/frame/config',
  //   children: [
  //     {
  //       path: 'quick',
  //       component: twIntegrateQuick,
  //       redirect: '/integrate/quick/account',
  //       children: [
  //         {
  //           path: '/integrate/quick/account',
  //           name: 'TWPAAS1200000000004',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/quick/createApp',
  //           name: 'TWPAAS1200000000005',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/quick/tools',
  //           name: 'TWPAAS1200000000006',
  //           component: twDocComponent
  //         }
  //       ]
  //     },
  //     {
  //       path: 'frame',
  //       component: twIntegrateFrame,
  //       redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/frame/readme' : '/integrate/frame/config',
  //       children: [
  //         {
  //           path: '/integrate/frame/readme',
  //           name: 'TWPAAS1200000000007',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/construct',
  //           name: 'TWPAAS1200000000008',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/config',
  //           name: 'TWPAAS1200000000009',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/safe',
  //           name: 'TWPAAS1200000000010',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/log',
  //           name: 'TWPAAS1200000000011',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/logCollection',
  //           name: 'TWPAAS1200000000012',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/task',
  //           name: 'TWPAAS1200000000013',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/excel',
  //           name: 'TWPAAS1200000000014',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/encrypt',
  //           name: 'TWPAAS1200000000015',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/streamingMedia',
  //           name: 'TWPAAS1200000000016',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/upload',
  //           name: 'TWPAAS1200000000017',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/richText',
  //           name: 'TWPAAS1200000000018',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/onlineText',
  //           name: 'TWPAAS1200000000019',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/power',
  //           name: 'TWPAAS1200000000020',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/frame/behaviorCollection',
  //           name: 'TWPAAS1200000000021',
  //           component: twDocComponent
  //         }
  //       ]
  //     },
  //     {
  //       path: 'api',
  //       component: twIntegrateApi,
  //       redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/api/readme' : '/integrate/api/authentication',
  //       children: [
  //         {
  //           path: '/integrate/api/readme',
  //           name: 'TWPAAS1200000000022',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/openApiSummary',
  //           name: 'TWPAAS1200000000023',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/debug',
  //           name: 'TWPAAS1200000000024',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/identitySummary',
  //           name: 'TWPAAS1200000000025',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/authentication',
  //           name: 'TWPAAS1200000000026',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/sso',
  //           name: 'TWPAAS1200000000027',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/wxqqLogin',
  //           name: 'TWPAAS1200000000107',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/apiSummary',
  //           name: 'TWPAAS1200000000028',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/authorize',
  //           name: 'TWPAAS1200000000029',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/token',
  //           name: 'TWPAAS1200000000030',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/refreshToken',
  //           name: 'TWPAAS1200000000031',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/userList',
  //           name: 'TWPAAS1200000000032',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getUserByToken',
  //           name: 'TWPAAS1200000000033',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/userInfo',
  //           name: 'TWPAAS1200000000034',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/checkUserRepeat',
  //           name: 'TWPAAS1200000000035',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getUserOrgList',
  //           name: 'TWPAAS1200000000036',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/org',
  //           name: 'TWPAAS1200000000037',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/joinSearchSchools',
  //           name: 'TWPAAS1200000000038',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getSchool',
  //           name: 'TWPAAS1200000000039',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryTermList',
  //           name: 'TWPAAS1200000000040',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryTimetableList',
  //           name: 'TWPAAS1200000000041',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/joinSearchClasses',
  //           name: 'TWPAAS1200000000042',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getClass',
  //           name: 'TWPAAS1200000000043',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryTeachers',
  //           name: 'TWPAAS1200000000044',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getTeacherInfo',
  //           name: 'TWPAAS1200000000045',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryTeachs',
  //           name: 'TWPAAS1200000000046',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryStudents',
  //           name: 'TWPAAS1200000000047',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getStudentInfo',
  //           name: 'TWPAAS1200000000048',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryParentList',
  //           name: 'TWPAAS1200000000049',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getParentInfo',
  //           name: 'TWPAAS1200000000050',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryDictTypeList',
  //           name: 'TWPAAS1200000000051',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryDictItemList',
  //           name: 'TWPAAS1200000000052',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryCurriculumWeekList',
  //           name: 'TWPAAS1200000000053',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryCurriculumDayList',
  //           name: 'TWPAAS1200000000054',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryBuildingList',
  //           name: 'TWPAAS1200000000055',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryClassroomList',
  //           name: 'TWPAAS1200000000056',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/searchAttendance',
  //           name: 'TWPAAS1200000000057',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/saveMessage',
  //           name: 'TWPAAS1200000000058',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/unReadMsgCount',
  //           name: 'TWPAAS1200000000059',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/msgList',
  //           name: 'TWPAAS1200000000060',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/sessionList',
  //           name: 'TWPAAS1200000000061',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/sessionView',
  //           name: 'TWPAAS1200000000062',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/setReaded',
  //           name: 'TWPAAS1200000000063',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/deleteMessage',
  //           name: 'TWPAAS1200000000064',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/deleteSession',
  //           name: 'TWPAAS1200000000065',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/unReadMsgList',
  //           name: 'TWPAAS1200000000066',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/integrateJava',
  //           name: 'TWPAAS1200000000067',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/integrateSpringCloud',
  //           name: 'TWPAAS1200000000068',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/upload',
  //           name: 'TWPAAS1200000000069',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/download',
  //           name: 'TWPAAS1200000000070',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/convert',
  //           name: 'TWPAAS1200000000071',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getQuestionList',
  //           name: 'TWPAAS1200000000072',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/getQuestionInfo',
  //           name: 'TWPAAS1200000000073',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/translate',
  //           name: 'TWPAAS1200000000074',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/recognition',
  //           name: 'TWPAAS1200000000075',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/synthesis',
  //           name: 'TWPAAS1200000000076',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/ocr',
  //           name: 'TWPAAS1200000000077',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/clientIntegrate',
  //           name: 'TWPAAS1200000000078',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/acessAuth',
  //           name: 'TWPAAS1200000000079',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/updateAuth',
  //           name: 'TWPAAS1200000000080',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/revokeAuth',
  //           name: 'TWPAAS1200000000081',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/applyTask',
  //           name: 'TWPAAS1200000000082',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/updateTask',
  //           name: 'TWPAAS1200000000083',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/enableTask',
  //           name: 'TWPAAS1200000000084',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/romoveTask',
  //           name: 'TWPAAS1200000000085',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryTask',
  //           name: 'TWPAAS1200000000086',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/statuses',
  //           name: 'TWPAAS1200000000087',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/comment',
  //           name: 'TWPAAS1200000000088',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/visit',
  //           name: 'TWPAAS1200000000089',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/kafka',
  //           name: 'TWPAAS1200000000090',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/sdk',
  //           name: 'TWPAAS1200000000091',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/errorCodeStandard',
  //           name: 'TWPAAS1200000000092',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/errorCodeList',
  //           name: 'TWPAAS1200000000093',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/addGoods',
  //           name: 'TWPAAS1200000000108',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/modifyGoods',
  //           name: 'TWPAAS1200000000109',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryGoods',
  //           name: 'TWPAAS1200000000110',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/saveOrder',
  //           name: 'TWPAAS1200000000111',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/cancelOrder',
  //           name: 'TWPAAS1200000000112',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/queryOrder',
  //           name: 'TWPAAS1200000000113',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/api/payment',
  //           name: 'TWPAAS1200000000114',
  //           component: twDocComponent
  //         }
  //       ]
  //     },
  //     {
  //       path: 'faq',
  //       component: twIntegrateFaq,
  //       redirect: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? '/integrate/faq/apiQuestion' : '/integrate/faq/accessQuestion',
  //       children: [
  //         {
  //           path: '/integrate/faq/apiQuestion',
  //           name: 'TWPAAS1200000000094',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/faq/accessQuestion',
  //           name: 'TWPAAS1200000000095',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/faq/userQuestion',
  //           name: 'TWPAAS1200000000096',
  //           component: twDocComponent
  //         },
  //         {
  //           path: '/integrate/faq/businessQuestion',
  //           name: 'TWPAAS1200000000097',
  //           component: twDocComponent
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/ecr',
  //   component: twEcrLeft,
  //   redirect: '/ecr/base/xkdhjk',
  //   children: [
  //     {
  //       path: '/ecr/base/xkdhjk',
  //       name: 'TWECR0000000000001',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqxkjk',
  //       name: 'TWECR0000000000002',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqxdjk',
  //       name: 'TWECR0000000000003',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqnjjk',
  //       name: 'TWECR0000000000004',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqbbjk',
  //       name: 'TWECR0000000000005',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqcbjk',
  //       name: 'TWECR0000000000006',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqzylxjk',
  //       name: 'TWECR0000000000007',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqtxjk',
  //       name: 'TWECR0000000000008',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqsjlxjk',
  //       name: 'TWECR0000000000009',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqsblbjk',
  //       name: 'TWECR0000000000010',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqzjmljk',
  //       name: 'TWECR0000000000011',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/base/hqzsdmljk',
  //       name: 'TWECR0000000000012',
  //       component: twDocComponent
  //     },
  //     // 资源中心接口
  //     {
  //       path: '/ecr/resource/zyscjk',
  //       name: 'TWECR1000000000001',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/resource/zyxzjk',
  //       name: 'TWECR1000000000002',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/resource/hqzyxqjk',
  //       name: 'TWECR1000000000003',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/resource/hqspkczylbjk',
  //       name: 'TWECR1000000000004',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/resource/hqzylbjk',
  //       name: 'TWECR1000000000005',
  //       component: twDocComponent
  //     },
  //     // 运营中心
  //     {
  //       path: '/ecr/yyzx/yhtjscjk',
  //       name: 'TWECR2000000000001',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/yyzx/yhdzqxdzjk',
  //       name: 'TWECR2000000000002',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/ecr/yyzx/hqsclbjk',
  //       name: 'TWECR2000000000003',
  //       component: twDocComponent
  //     }
  //   ]
  // },
  // {
  //   path: '/design',
  //   component: twDesignLeft,
  //   redirect: '/design/summary',
  //   children: [
  //     {
  //       path: '/design/summary',
  //       name: 'TWPAAS1200000000098',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/concise',
  //       name: 'TWPAAS1200000000099',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/flexible',
  //       name: 'TWPAAS1200000000100',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/control',
  //       name: 'TWPAAS1200000000101',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/layout',
  //       name: 'TWPAAS1200000000102',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/color',
  //       name: 'TWPAAS1200000000103',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/font',
  //       name: 'TWPAAS1200000000104',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/icon',
  //       name: 'TWPAAS1200000000105',
  //       component: twDocComponent
  //     },
  //     {
  //       path: '/design/button',
  //       name: 'TWPAAS1200000000106',
  //       component: twDocComponent
  //     }
  //   ]
  // },
  {
    path: '/search',
    name: 'searchDocument',
    component: __WEBPACK_IMPORTED_MODULE_6__web_doc_search___default.a
  }, {
    path: '/MenuManage',
    component: __WEBPACK_IMPORTED_MODULE_8__web_doc_document_menu___default.a,
    redirect: '/MenuManage/summary',
    children: [{
      path: '/MenuManage/summary',
      name: 'TWPAAS1200000000098',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/concise',
      name: 'TWPAAS1200000000099',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/flexible',
      name: 'TWPAAS1200000000100',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/control',
      name: 'TWPAAS1200000000101',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/layout',
      name: 'TWPAAS1200000000102',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/color',
      name: 'TWPAAS1200000000103',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/font',
      name: 'TWPAAS1200000000104',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/icon',
      name: 'TWPAAS1200000000105',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }, {
      path: '/MenuManage/button',
      name: 'TWPAAS1200000000106',
      component: __WEBPACK_IMPORTED_MODULE_5__web_doc_component___default.a
    }]
  }, {
    path: '/signup',
    component: __WEBPACK_IMPORTED_MODULE_2__web_signup___default.a
  }, {
    path: '/find_password',
    component: __WEBPACK_IMPORTED_MODULE_4__web_find_password___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_3__web_404___default.a
  }, {
    path: '/style',
    component: __WEBPACK_IMPORTED_MODULE_9__web_style___default.a
  }]
}));

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(15);
/**
 * Created by superman on 17/2/16.
 */



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  state: {
    activeAppId: '',
    isAdmin: false,
    activeId3th: '',
    activeId2th: '',
    MenuId: [],
    MenuList2th: [],
    MenuList3th: [],
    typeOfAppList: [],
    pageName: 'Doc',
    searchKey: '',
    userName: '',
    orgId: '',
    orgLogo: '',
    token: null,
    title: '',
    userId: '',
    tenantId: '',
    roleIdList: [],
    orgName: '',
    gateway_url: window.location.origin + '/api',
    login_url: window.location.origin,
    eco_url: 'http://open.teewon.net',
    client_secret: '4149bcc45a16e2f3',
    sectionDic: {},
    subjectDic: {},
    areaName: '',
    systemConfig: {},
    user2OrgList: [],
    weakPwdFlag: false,
    lang: window.localStorage.getItem('tw_i18n_local') || 'zh_CN',
    hasDoc: true,
    editor: {
      goEdit: false,
      isAdmin: false,
      isEditing: false
    }
  },
  mutations: {
    'login': function login(state, data) {
      // localStorage.token = data
      state.token = data[0];
      state.orgId = data[1] === 'null' ? '' : data[1];
      state.userName = data[2];
      state.userId = data[3];
      state.tenantId = data[4];
      state.orgName = data[5];
      state.roleIdList = data[6];
      state.areaName = data[7];
      state.user2OrgList = data[8];
    },
    'logout': function logout(state) {
      // localStorage.removeItem('token');
      state.token = null;
      state.userId = '';
      state.userName = '';
      state.userId = '';
      state.tenantId = '';
      state.orgName = '';
      state.roleIdList = [];
      state.orgLogo = '';
      state.areaName = '';
      state.weakPwdFlag = false;
    },
    'roles': function roles(state, data) {
      state.roles = data;
    },
    'orgLogo': function orgLogo(state, data) {
      state.orgLogo = data;
    },
    'systemConfig': function systemConfig(state, data) {
      state.systemConfig = data;
    },
    'weakPwdFlag': function weakPwdFlag(state, data) {
      state.weakPwdFlag = data;
    },
    'changePageName': function changePageName(state, data) {
      state.pageName = data;
    },
    'changeMenuList2th': function changeMenuList2th(state, data) {
      state.MenuList2th = data;
    },
    'changeMenuList3th': function changeMenuList3th(state, data) {
      state.MenuList3th = data;
    },
    'changeMenuId': function changeMenuId(state, data) {
      state.MenuId = data;
    },
    'hasDoc': function hasDoc(state, data) {
      state.hasDoc = data;
    },
    'changeTypeOfAppList': function changeTypeOfAppList(state, data) {
      state.typeOfAppList = data;
    },
    'changeActiveId2th': function changeActiveId2th(state, data) {
      state.activeId2th = data;
    },
    'changeActiveAppId': function changeActiveAppId(state, data) {
      state.activeAppId = data;
    },
    'changeActiveId3th': function changeActiveId3th(state, data) {
      state.activeId3th = data;
    },
    'areYouAdmin': function areYouAdmin(state, data) {
      state.isAdmin = data;
    },
    'changeUrl': function changeUrl(state, data) {
      state.gateway_url = data;
    },
    'changeLoginUrl': function changeLoginUrl(state, data) {
      state.login_url = data;
    }
  }
}));

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAFF0lEQVRYw62XW2wUVRzGfzM7u93tstvbtuVuS1tKKdCKLJAiRQpYgkQQY5Y+SJsmEoP6QAxg9EEexIjGSGJMCOGhhAdsoj4BIQiWBBChKLWiXEohthR6v+z9MrPjQ7elW7azI+H/NDPnO//vO/85l+8I6IzGZnUa8BqwFigH8oG0WPMI8ABoAZqAUy6n4NWTV9BBXAjsA2oAq069PuAEcNDlFO49k4DGZtUM7Ad2Aya9lZoUYeAQ8KnLKQR1C2hsVguAHxgt9fOIFuCtRNUQE5AvBS5rkqsqvuHe/yOgHLgUyz11BWL/+1cge6pMQe8QZw9/SMA9QPqMfPr+/QfJmEJ6bh5FKzdTsKxaS0gfUDGxEsIEcgtwBShL1NM72M2jO9f4+0Ij3e0tT7WLooGZC1awcdchjGbNudoKrHQ5hcBkAQeBvYl6uPsf8tOBGiIhP3I4qJUciy2TqvrPmbt4tRbsS5dT2DcuIDbpbgHGROhzR/bQdu00ekOUjGzd00BuQflUkAiw0OUU7o1Nwo+mIpfDQdr/+Fk3OUBUjvDbj99oQYwxTsTGZtXG6CaTMNx9nUTlSNy3Cmcpn31cD0BWhp2aN6vY/sbaOMyjtt8JBzxaIrY3Nqs2CdiExg4nR0Jx73U11exwvUokorCmooy9H7hITTUDMDjs4WzT9VGgquId6iHTYpsqtRXYJALrtGSarWnjzyteKqF2ezWCIGAySezfVztODrCrfgt225OxGKSkG+g6EViihbA5ZmFMsQBQs61KM1ua3crWTauA0WU5LXN6MgFLRKBACyEIItMLX8SRlUHZooJkCdm2eTUmk5HsvFI9FSiQALtmBQw+vtq7laYmR1LysSpUVy1n+ZoN9AsRwqpRC24XkyW0GgLkpkuUFM/TJQCgsqKclxfayTKOJMWKgFsL0B/JIBQ1kTcvX7eAouIiVARGlKT2wS0C7VoIWTXwy/ByhsjVLSBsSOeGdwF+xZIM2i4yejhohkex8qevGEU1JCVXVJEr7jLuBebq0doqAuf1IENREzf9hUlxN/2FBKO6DdR5ETjNqIdLGnf8eZojexCczR2/7rniB06LLqfgAb7X2+v2sIOuLjchvx9VVVFVlZA/wF8DOVz3lOhNA3DC5RQ8UuzlC2AHk07EAU+YplsDdA4EkJUoR2tzKJ2eQtf5TroHYyBBAFXFzn22VM7h9mAK9Q29GA0CszLNvFKSRY49ZTJ5BDgIMU8Ys0hx56c/rHDs0kNuP/LiCymEZJUen4hksWPLm2CaVBUAS04+JruDLjeE5Si+kMLdxz6OXXyINyhPFnDI5RTaxgXEYj8TVsSpG734Q0pcr4aLQ4RklczSKrLKqrHOLCZ15nwyF1WRvex1IorK8cvDcX1CkSgnW+IMbGuMa7SAE1vGTOn1+8PZZ1r7Ev64xbPN7K52sDTPgig8KUJrZ5Cvz/TR0pHYsq1f5GBlYcbUpnR8lJdl59ELHVdG/LLmoreZRXLsEoIA3SMy3mBUC47dIil1lXNWvVNpvDrxe8KLyc6GvnV3H/tODnjDZp5DZE0zBefPsG4+Upf91J4z5dXsveP96T0j4TNtPb4V0aj6TMSiKFCUa72am2ba+N3bjuFEmKSX050NfRt63aFvO/oDxRFFnxDJIPCCw3I3x57y/pG6bE1Hm1TAWLx7rD/XH1Y+cQfk9Z6APNcTlC0hOSoCpEhi1GaWAjaL1GG3SOdSTYYDh2sdPXry/gdak82O0GEFzAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(591),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2961d110",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-854ff1a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(592),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36122fd9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_css_main_css__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_store__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_http__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_i18n__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_register__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale__);
// 引入库
// ==============================



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// 引入样式
// ==============================



// 引入配置
// ==============================






// import utils from '@/config/cookieUtils'

// 注册所有公共组件
// ==============================





// 渲染视图
// ==============================
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.axios = __WEBPACK_IMPORTED_MODULE_8__config_http__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype._ = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a;

var currentLang = window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US';
if (currentLang !== 'en_US') {
  currentLang = 'zh_CN';
}
var i18n = new __WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */]({
  locale: currentLang, // 语言标识
  messages: {
    'zh_CN': __webpack_require__(280), // 中文语言包
    'en_US': __webpack_require__(279) // 英文语言包
  }
});

if (currentLang === 'en-US') {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a, { enLocale: __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en___default.a });
  __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en___default.a);
} else {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a, { zhLocale: __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN___default.a });
  __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN___default.a);
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_5__config_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__config_store__["a" /* default */],
  axios: __WEBPACK_IMPORTED_MODULE_8__config_http__["a" /* default */],
  lodash: __WEBPACK_IMPORTED_MODULE_9_lodash___default.a,
  render: function render(createElement) {
    var _this = this;

    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', function () {
        var currentPath = window.location.hash.slice(1);
        if (_this.$route.path !== currentPath) {
          _this.$router.push(currentPath);
        }
      }, false);
    }
    return createElement(__WEBPACK_IMPORTED_MODULE_6__App___default.a);
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_store__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__ = __webpack_require__(43);

/**
 * Created by superman on 17/2/16.
 * http配置
 */






// axios 配置
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = window.location.origin + '/api';
__WEBPACK_IMPORTED_MODULE_2__config_store__["a" /* default */].commit('changeUrl', __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL);
__WEBPACK_IMPORTED_MODULE_2__config_store__["a" /* default */].commit('changeLoginUrl', window.location.origin);
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json';

// http request 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  var token = __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].get('Access-Token');
  if (token && token !== 'null') {
    config.headers['Access-Token'] = token;
    config.headers['X-User-Account'] = __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].get('X-User-Account');
    config.headers['Current-Org-Id'] = __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].get('Current-Org-Id');
    config.headers['X-Client-Language'] = __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].get('X-Client-Language');
    config.headers['Role-Ids'] = __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].get('CURRENT_ROLE_ID_LIST');
    if (config.headers['Tenant-Id'] === null || config.headers['Tenant-Id'] === '' || config.headers['Tenant-Id'] === 'null' || config.headers['Tenant-Id'] === undefined) {
      config.headers['Tenant-Id'] = __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].get('CURRENT_ROLE_ID');
    }
  }
  // 语言环境设置
  var currentLang = window.localStorage.getItem('tw_i18n_local');
  if (currentLang === 'en_US') {
    config.headers['X-Client-Language'] = 'en_US';
  } else {
    config.headers['X-Client-Language'] = 'zh_CN';
  }
  config.headers['X-Client-Id'] = '50f104a9932e412cba81a0224d78bc92';
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// http response 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  var serverResult = response.data.serverResult;
  if (serverResult && serverResult.resultCode !== '200' && serverResult.resultCode !== '10007' && serverResult.resultCode !== '10008') {
    var msg = serverResult.internalMessage ? serverResult.internalMessage : serverResult.resultMessage;
    if (serverResult.resultCode === 'PUC102PUC10211510000') {
      var currentLang = window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US';
      if (currentLang === 'en_US') {
        msg = 'Account is not bound role, please contact administrator.';
      } else {
        msg = '账号没有绑定角色，请联系管理员';
      }
    }
    __WEBPACK_IMPORTED_MODULE_3_element_ui___default.a.Message({
      type: 'error',
      message: msg
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
  }
  return response;
}, function (error) {
  if (error.response && error.response.data) {
    var errorJson = error.response.data;
    if (errorJson.resultCode && errorJson.resultCode === 4210) {
      __WEBPACK_IMPORTED_MODULE_3_element_ui___default.a.Message({
        type: 'error',
        message: '账号已在其它地方登录',
        onClose: function onClose() {
          __WEBPACK_IMPORTED_MODULE_2__config_store__["a" /* default */].commit('logout');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].set('Access-Token', null);
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].set('Current_User_Id', '');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].set('Current-Org-Id', '');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].set('CURRENT_LOGIN_NAME', '');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].set('CURRENT_TENANT_ID', '');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].set('CURRENT_ORG_NAME', '');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].set('CURRENT_ROLE_ID_LIST', []);
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('TW_STA_CITY_ID');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('TW_STA_IP');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('TW_STA_SESSION_ID');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('TW_STA_SCHOOL_NUM');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('TW_STA_TEACHER_NUM');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('TW_STA_STUDENT_NUM');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('AUTO_LOGIN');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('LOGIN_NAME');
          __WEBPACK_IMPORTED_MODULE_4__config_cookieUtils__["a" /* default */].delete('LOGIN_PASSWORD');
          location.reload();
        }
      });
      return;
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tw_footer__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tw_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tw_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tw_header__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tw_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tw_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tw_totop__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tw_totop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tw_totop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_fix__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_bottom__ = __webpack_require__(277);
// 注册通用的全局组件
// ==============================




var components = [__WEBPACK_IMPORTED_MODULE_1__components_tw_footer___default.a, __WEBPACK_IMPORTED_MODULE_3__components_tw_totop___default.a, __WEBPACK_IMPORTED_MODULE_2__components_tw_header___default.a];

components.forEach(function (component) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(component.name, component);
});

// 注册通用的全局指令
// ==============================



var directives = [__WEBPACK_IMPORTED_MODULE_4__directives_fix__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__directives_bottom__["a" /* default */]];
directives.forEach(function (directive) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive(directive.name, directive);
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 工具类方法
// ==============================
var twui = {
  // 获取元素在文档中的位置
  offset: function offset(el) {
    var left = el.offsetLeft;
    var top = el.offsetTop;
    var parent = el.offsetParent;

    while (parent !== null) {
      left += parent.offsetLeft;
      top += parent.offsetTop;
      parent = parent.offsetParent;
    }

    return {
      left: left,
      top: top
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (twui);

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setBottom = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bottom',
  hooks: {
    inserted: function inserted(el, binding) {
      debugger;
      setBottom = function setBottom() {
        var rect = el.getBoundingClientRect();
        var top = rect.top + window.pageYOffset - document.documentElement.clientTop;
        var windowHieght = window.innerHeight;
        var value = parseInt(binding.value) ? parseInt(binding.value) : 0;

        if (binding.modifiers.height) {
          el.style.height = windowHieght - top - value + 'px';
        } else {
          el.style.minHeight = windowHieght - top - value + 'px';
        }
      };

      setBottom();

      // 注册全局调用函数
      if (!(window.twBottomHandlers instanceof Array)) {
        window.twSetBottomHandlers = [];
        window.twSetBottoms = function () {
          window.twSetBottomHandlers.forEach(function (handler) {
            handler();
          });
        };
      }

      window.twSetBottomHandlers.push(setBottom);

      window.addEventListener('resize', setBottom);
    },
    componentUpdated: function componentUpdated(el, binding) {
      setBottom();
    },
    unbind: function unbind() {
      window.removeEventListener('resize', setBottom);

      // 移除全局调用函数
      if (window.twBottomHandlers instanceof Array) {
        window.twSetBottomHandlers = window.twSetBottomHandlers.filters(function (handler) {
          return handler !== setBottom;
        });
      }
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_twui__ = __webpack_require__(276);
// 指令:原位置悬浮(fix)
// ==============================


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fix',
  inserted: function inserted(el, binding, vnode) {
    var offset = __WEBPACK_IMPORTED_MODULE_0__config_twui__["a" /* default */].offset(el);
    var fixTop = binding.value;
    offset.origiLeft = el.style.left;

    __WEBPACK_IMPORTED_MODULE_0__config_twui__["a" /* default */].fix = function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var className = el.className;

      if (scrollTop > fixTop) {
        if (className.indexOf(' xfix') !== -1) return;
        el.className = className + ' xfix';
        el.style.left = offset.left + 'px';
      } else {
        if (className.indexOf(' xfix') === -1) return;
        el.className = className.replace(' xfix', '');
        el.style.left = offset.origiLeft;
      }
    };

    window.addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_0__config_twui__["a" /* default */].fix, false);
  },
  unbind: function unbind() {
    window.addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_0__config_twui__["a" /* default */].fix, false);
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return m; });
var m = {
  platform_name: 'Developer Center',
  changeLangConfirm: 'Are you sure to switch the language?',
  confirmText: 'Confirm',
  cancel: 'Cancel ',
  commonTip: 'Prompt',
  cancelManual: 'Cancel Manual',
  application_development_scenario: 'Application development scenario',
  overview_of_open_capabilities: 'Overview of open capabilities',
  noun_interpretation: 'Noun interpretation',
  update_log: 'Update log',
  registered_developer_account: 'Registered developer account',
  create_docking_application: 'Create docking application',
  use_of_frontend_debugging_tools: 'Use of front-end debugging tools',
  quick_build_service: 'Quick build service',
  configuration_center: 'Configuration center',
  security_components: 'Security components',
  log_framework: 'Log framework',
  log_collection: 'Log collection',
  distributed_tasks: 'Distributed tasks',
  excel_import_and_export: 'Excel import and export',
  encryption_and_decryption_module: 'Encryption and decryption module',
  streaming_media: 'Streaming media',
  file_upload_component: 'File upload component',
  rich_text_component: 'Rich text component',
  online_text_display_component: 'Online text display component',
  front_end_permission_component: 'Front end permission component',
  behavior_collection_module: 'Behavior collection module',
  must_read_before_development: 'Must read before development',
  open_api_summary: 'Open API Summary',
  interface_debugging: 'Interface debugging',
  summary: 'Summary',
  unified_authentication: 'Unified authentication',
  single_sign_on: 'Single sign on',
  get_authorization_code: 'Get authorization code',
  obtaining_a_token: 'Obtaining a token',
  refresh_token: 'Refresh token',
  get_user_list: 'Get user list',
  getting_user_information_token: 'Getting user information(Token)',
  getting_user_information_userid: 'Getting user information(UserId)',
  user_name_duplicate_check: 'User name duplicate check',
  get_user_organization_information: 'Get user organization information',
  acquiring_institutions_according_to_id: 'Acquiring institutions according to ID',
  query_school_list: 'Query school list',
  query_school_id: 'Query School(ID)',
  query_term_list: 'Query term list',
  query_timetable_list: 'Query timetable List',
  query_class_list: 'Query class list',
  query_class_id: 'Query Class(ID)',
  query_teacher_list: 'Query teacher list',
  query_teacher_id: 'Query teacher(ID)',
  query_teaching_information_list: 'Query teaching information list',
  query_student_list: 'Query student list',
  query_student_id: 'Query student(ID)',
  query_parents_list: 'Query parents list',
  query_parent_id: 'Query parent(ID)',
  query_dictionary_type_list: 'Query dictionary type list',
  query_dictionary_information_list: 'Query dictionary information list',
  query_weekly_schedule__template_list: 'Query weekly schedule (template) list',
  query_daily_schedule_list: 'Query daily schedule list',
  query_teaching_building: 'Query teaching building',
  query_classroom: 'Query classroom',
  query_attendance_information: 'Query attendance information',
  storage_message: 'Storage message',
  number_of_unread_messages: 'Number of unread messages',
  view_message_list: 'View message list',
  view_session_list: 'View session list',
  view_session_messages: 'View session messages',
  update_to_read: 'Update to read',
  removal_message: 'Removal message',
  delete_the_session: 'Delete the session',
  query_unread_message: 'Query unread message',
  java_client_rapid_integration: 'Java client rapid integration',
  spring_cloud_client_rapid_integration: 'Spring Cloud client rapid integration',
  file_upload: 'File upload',
  file_download: 'File download',
  file_convert: 'file convert',
  get_a_list_of_questions: 'Get the list test question',
  get_details_of_questions: 'Get details of questions',
  translate: 'Translate',
  speech_recognition: 'Speech recognition',
  speech_synthesis: 'Speech synthesis',
  word_recognition: 'Character recognition',
  client_rapid_integration: 'Fast integration of client',
  obtaining_authorization: 'Obtaining authorization',
  update_authorization: 'Update authorization',
  authorization_recovery: 'Authorization revocation',
  apply_for_subscriptions: 'Apply for subscriptions',
  modify_subscriptions: 'Modify subscriptions',
  open_subscribe: 'Enable subscription',
  unsubscribe: 'Cancel subscription',
  query_subscription: 'Query subscription',
  query_text: 'Post Query',
  query_comment: 'Comments Query',
  query_log: 'Query Log',
  kafka_message: 'Kafka message',
  sdk_download: 'SDK download',
  error_code_specification: 'Error code specification',
  global_error_code: 'Global error code',
  interface_call_problem: 'Interface call problem',
  access_problem: 'Access problem',
  user_problem: 'User problem',
  business_problems: 'Business problems',
  default_title: 'Default Title',
  common_problem: 'Common problem',
  identity_check: 'Authentication',
  basic_data_api: 'Basic Data Api',
  curriculum_schedule: 'Curriculum schedule',
  attendance_interface: 'Attendance Interface',
  message_center: 'Message center',
  file_service: 'File service',
  question_service: 'Question service',
  ai_service: 'AI service',
  opinion_service: 'Public opinion service',
  instant_message: 'Instant message',
  error_code: 'Error code',
  service: 'Service',
  front_end_component: 'Front end component',
  dev_ready: 'Development preparation',
  quick_start: 'Quick start',
  frame: 'Framework',
  open_api: 'Open API',
  input_key: 'please input key',
  update_time: 'Update time',
  editor: 'Editor',
  upload_file: 'Upload File',
  save: 'Save',
  cancle: 'Cancle',
  support_file_type_info: 'Support file type：image ,office',
  introduce: 'Introduce',
  design: 'Design',
  integrate: 'Integrate',
  logout: 'Logout',
  login: 'Login',
  design_principles: 'Design principles',
  concise_and_clear: 'Concise And Clear',
  flexible_and_efficient: 'Flexible And Efficient',
  user_control: 'User Control',
  visual_norms: 'Visual Norms',
  layout: 'Layout',
  color: 'Color',
  font: 'Font',
  icon: 'Icon',
  button: 'Button',
  loginAccountPlaceHolder: 'Account, phone number or email',
  inputPwdTip: 'Enter your password',
  selectOrgTip: 'elect an organization',
  yzmPlaceHolder: 'Verification code',
  yzmEmptyTip: 'The verification code is required',
  changeAnother: 'Change',
  loginFailed: 'Login failed, please contact the administrator.',
  selectSuiteBroseTip: 'Please use IE9 or higher, Chrome, Firefox and other applicable browsers',
  loginNameRepeatTip: 'Repeated login name, please choose your own user name to log in',
  userStatusNotCorrectTip: 'This user isn\'t in normal status, please contact administrator',
  userNotExistTip: 'Login name does not exist.',
  loginPwdError: 'Password wrong.',
  loginNameInputTip: 'Enter a user name',
  checkCodeError: 'Verification code error',
  getCheckcodeError: 'Failed to obtain the verification code',
  xwqqlogin: 'WeChat or QQ login',
  operation: 'Operation Hub',
  addGoods: 'Add Goods',
  modifyGoods: 'Modify Goods',
  queryGoods: 'Query Goods',
  saveOrder: 'Save Order',
  cancelOrder: 'Cancel Order',
  queryOrder: 'Query Order',
  ssoFailed: 'Login failed.',
  payService: 'Payment service',
  howtoLogin: 'log in',
  howtoFindPwd: 'How do I log in?',
  xtbg: 'Cooperative office',
  xtsyxd: 'System Use Wizard',
  wjdc: 'questionnaire investigation',
  zymgnjs: 'Main page layout and function introduction',
  xtsz: 'System settings',
  dzgrzy: 'How to customize personal homepage',
  glbmyhxx: 'Management department and user information',
  kqgzsz: 'Attendance Rule Settings',
  lczx: 'Process Center',
  lcfqxj: 'Initiate creation',
  lcwddb: 'My To Do',
  jbgz: 'Handling and tracking',
  lscx: 'Historical query',
  xzbg: 'Administrative office',
  rw: 'task',
  grrwzy: 'Personal Tasks Home Page',
  rwxm: 'project',
  rwdt: 'dynamic',
  dcwj: 'questionnaire',
  cjwj: 'Create questionnaire',
  hswj: 'Take back the questionnaire',
  wjcx: 'Questionnaire Query&Delete',
  ckwjdt: 'Check the answers to the questionnaire',
  txwj: 'Fill in the questionnaire',
  kmwp: 'KM network disk (knowledge management)',
  kmgnjs: 'Km function introduction',
  kmqxqb: 'Differences in the permissions of different roles of km to use the network disk',
  kmdlfs: 'How to log in to the km network disk',
  kmsy: 'How to log in to the km network disk',
  kmgrwp: 'Personal online disk',
  kmggwp: 'Public network disk',
  znxxgg: 'In station messages and announcements',
  xxrk: 'entrance',
  xtxx: 'System messages',
  yhxx: 'User Message',
  xxgg: 'Notice',
  fbwj: 'Issue questionnaire',
  wjhswj: 'Collect the answer sheet',
  wjfxxz: 'Analysis&Download',
  tjfxxz: 'Statistics and analysis',
  ckxzdj: 'View the download answer sheet',
  wjfz: 'Questionnaire copy',
  wjsc: 'Questionnaire deletion',
  wjzx: 'Questionnaire Center',
  wjcjwj: 'Create questionnaire',
  wjsjwj: 'Design questionnaire',
  wjsz: 'Questionnaire Settings',
  wjwgsz: 'Appearance Settings',
  developer_platform: 'developer platform',
  BusinessAPP: 'business application',
  document_menu_management: 'Document menu management',
  zwwd: 'No document',
  cdlmsz: 'Menu Column Settings',
  menuName: 'Menu Name',
  superior: 'superior',
  selectTop: 'Select Superior',
  nothing: 'nothing',
  sortNum: 'sortNum',
  appType: 'appType',
  appTypeTeching: 'appTypeTeching',
  appTypeStudy: 'appTypeStudy',
  appTypeManage: 'appTypeManage',
  appTypeEvaluate: 'appTypeEvaluate',
  appTypeResearch: 'appTypeResearch',
  appTypeResource: 'appTypeResource',
  appTypeOther: 'appTypeOther',
  appTypeClass: 'appTypeClass',
  appTypeOtherTools: 'appTypeOtherTools',
  qsycdmc: 'Please enter the menu name',
  qsrxh: 'Please enter the serial number',
  bccg: 'Saving succeeded',
  add: 'newly added',
  kfjk: 'Open interface',
  common: 'common',
  ssjg: 'Search results',
  mycxdjl: 'No matching records found',
  twtymyapi: 'Tianwen Unified Portal Platform API',
  twzjk: 'Tianwen Component Library',
  yhtx: 'User avatar'
};

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return m; });
var m = {
  platform_name: '文档中心',
  changeLangConfirm: '确定切换语言吗？',
  confirmText: '确定',
  cancel: '取消',
  commonTip: '提示',
  cancelManual: '取消了操作',
  application_development_scenario: '应用开发场景',
  overview_of_open_capabilities: '开放能力概览',
  noun_interpretation: '名词解释',
  update_log: '更新日志',
  registered_developer_account: '注册开发者账号',
  create_docking_application: '创建对接应用',
  use_of_frontend_debugging_tools: '前端调试工具使用',
  quick_build_service: '快速构建服务',
  configuration_center: '配置中心',
  security_components: '安全组件',
  log_framework: '日志框架',
  log_collection: '日志采集',
  distributed_tasks: '分布式任务',
  excel_import_and_export: 'Excel导入导出',
  encryption_and_decryption_module: '加解密组件',
  streaming_media: '流媒体',
  file_upload_component: '文件上传组件',
  rich_text_component: '富文本组件',
  online_text_display_component: '在线文本展示组件',
  front_end_permission_component: '前端权限组件',
  behavior_collection_module: '行为采集组件',
  must_read_before_development: '开发前必读',
  open_api_summary: 'Open API 简介',
  interface_debugging: '接口调试',
  summary: '概览',
  unified_authentication: '统一认证',
  single_sign_on: '单点登录',
  get_authorization_code: '获取授权码',
  obtaining_a_token: '获取令牌',
  refresh_token: '刷新令牌',
  get_user_list: '获取用户列表',
  getting_user_information_token: '获取用户信息(Token)',
  getting_user_information_userid: '获取用户信息(UserId)',
  user_name_duplicate_check: '用户名重复校验',
  get_user_organization_information: '获取用户机构信息',
  acquiring_institutions_according_to_id: '根据ID获取机构',
  query_school_list: '查询学校列表',
  query_school_id: '查询学校（ID）',
  query_term_list: '查询学期列表',
  query_timetable_list: '查询作息列表',
  query_class_list: '查询班级列表',
  query_class_id: '查询班级（ID）',
  query_teacher_list: '查询教师列表',
  query_teacher_id: '查询教师（ID）',
  query_teaching_information_list: '查询任教信息列表',
  query_student_list: '查询学生列表',
  query_student_id: '查询学生（ID）',
  query_parents_list: '查询家长列表',
  query_parent_id: '查询家长（ID）',
  query_dictionary_type_list: '查询字典类型列表',
  query_dictionary_information_list: '查询字典信息列表',
  query_weekly_schedule__template_list: '查询周课表（模板）列表',
  query_daily_schedule_list: '查询日课表列表',
  query_teaching_building: '查询教学楼',
  query_classroom: '查询教室',
  query_attendance_information: '查询考勤信息',
  storage_message: '存储消息',
  number_of_unread_messages: '未读消息数',
  view_message_list: '查看消息列表',
  view_session_list: '查看会话列表',
  view_session_messages: '查看会话内消息',
  update_to_read: '更新为已阅',
  removal_message: '删除消息',
  delete_the_session: '删除会话',
  query_unread_message: '查询未读消息',
  java_client_rapid_integration: 'Java客户端快速集成',
  spring_cloud_client_rapid_integration: 'Spring Cloud 客户端快速集成',
  file_upload: '文件上传',
  file_download: '文件下载',
  file_convert: '文件转换',
  get_a_list_of_questions: '获取试题列表',
  get_details_of_questions: '获取试题详情',
  translate: '翻译',
  speech_recognition: '语音识别',
  speech_synthesis: '语音合成',
  word_recognition: '文字识别',
  client_rapid_integration: '客户端快速集成',
  obtaining_authorization: '获取授权',
  update_authorization: '更新授权',
  authorization_recovery: '授权回收',
  apply_for_subscriptions: '申请订阅',
  modify_subscriptions: '修改订阅',
  open_subscribe: '开启订阅',
  unsubscribe: '取消订阅',
  query_subscription: '查询订阅',
  query_text: '贴文查询',
  query_comment: '评论查询',
  query_log: '日志查询',
  kafka_message: 'Kafka消息',
  sdk_download: 'SDK下载',
  error_code_specification: '错误码规范',
  global_error_code: '全局错误码',
  interface_call_problem: '接口调用问题',
  access_problem: '接入问题',
  user_problem: '用户问题',
  business_problems: '业务问题',
  default_title: '默认文档',
  common_problem: '常见问题',
  identity_check: '身份验证',
  basic_data_api: '基础数据API',
  curriculum_schedule: '课程表',
  attendance_interface: '考勤接口',
  message_center: '消息中心',
  file_service: '文件服务',
  question_service: '试题服务',
  ai_service: 'AI服务',
  opinion_service: '舆情服务',
  instant_message: '即时消息',
  error_code: '错误码',
  service: '服务',
  front_end_component: '前端组件',
  dev_ready: '开发准备',
  quick_start: '快速入门',
  frame: '框架',
  open_api: '开放API',
  input_key: '请输入关键字',
  update_time: '更新时间',
  editor: '编辑',
  upload_file: '上传文件',
  save: '保存',
  cancle: '取消',
  support_file_type_info: '支持上传文件类型：图片、office文档、视频文件',
  introduce: '平台介绍',
  design: '规范设计',
  integrate: '应用接入',
  logout: '退出',
  login: '登录',
  design_principles: '设计原则',
  concise_and_clear: '简洁清晰',
  flexible_and_efficient: '灵活高效',
  user_control: '用户控制',
  visual_norms: '视觉规范',
  layout: '布局',
  color: '色彩',
  font: '字体',
  icon: '图标',
  button: '按钮',
  loginAccountPlaceHolder: '请输入登录帐号、手机号或邮箱',
  inputPwdTip: '请输入密码',
  selectOrgTip: '请选择机构',
  yzmPlaceHolder: '请输入验证码',
  yzmEmptyTip: '必须填写验证码',
  changeAnother: '换一张',
  loginFailed: '登录失败，请联系管理员',
  selectSuiteBroseTip: '请用IE9以上的浏览器或谷歌、火狐等适用的浏览器',
  loginNameRepeatTip: '登录名重复请选择自己的用户登录',
  userStatusNotCorrectTip: '该用户不是正常状态，请联系管理员',
  userNotExistTip: '用户名不存在',
  loginPwdError: '密码错误',
  loginNameInputTip: '请输入用户名',
  checkCodeError: '验证码错误',
  getCheckcodeError: '获取验证码失败',
  xwqqlogin: '微信QQ登录',
  operation: '运营中心',
  addGoods: '新增商品',
  modifyGoods: '修改商品',
  queryGoods: '查询商品',
  saveOrder: '生成订单',
  cancelOrder: '取消订单',
  queryOrder: '查询订单',
  ssoFailed: '登录失败',
  payService: '支付服务',
  howtoLogin: '如何登录？',
  howtoFindPwd: '如何找回密码？',
  xtbg: '智慧办公',
  xtsyxd: '系统使用向导',
  wjdc: '问卷调查',
  zymgnjs: '主页面布局及功能介绍',
  xtsz: '系统设置',
  dzgrzy: '如何定制个人主页',
  glbmyhxx: '管理部门和用户信息',
  kqgzsz: '考勤规则设置',
  lczx: '流程中心',
  lcfqxj: '发起新建',
  lcwddb: '我的待办',
  jbgz: '经办跟踪',
  lscx: '历史查询',
  xzbg: '行政办公',
  rw: '任务',
  grrwzy: '个人任务主页',
  rwxm: '项目',
  rwdt: '动态',
  dcwj: '调查问卷',
  cjwj: '创建问卷',
  hswj: '回收问卷',
  wjcx: '问卷查询&删除',
  ckwjdt: '查看问卷答题情况',
  txwj: '填写问卷',
  kmwp: 'KM网盘（知识管理）',
  kmgnjs: 'km功能介绍',
  kmqxqb: 'km不同角色使用网盘权限的区别',
  kmdlfs: '登录km网盘的方式',
  kmsy: '首页',
  kmgrwp: '个人网盘',
  kmggwp: '公共网盘',
  znxxgg: '站内消息和公告',
  xxrk: '入口',
  xtxx: '系统消息',
  yhxx: '用户消息',
  xxgg: '公告',
  fbwj: '发布问卷',
  wjhswj: '回收答卷',
  wjfxxz: '分析&下载',
  tjfxxz: '统计与分析',
  ckxzdj: '查看下载答卷',
  wjfz: '问卷复制',
  wjsc: '问卷删除',
  wjzx: '问卷中心',
  wjcjwj: '创建问卷',
  wjsjwj: '设计问卷',
  wjsz: '问卷设置',
  wjwgsz: '外观设置',
  czwdxz: '操作手册下载',
  developer_platform: '开发平台',
  BusinessAPP: '业务应用',
  document_menu_management: '文档菜单管理',
  zwwd: '暂无文档',
  cdlmsz: '菜单栏目设置',
  menuName: '菜单名称',
  superior: '上级',
  selectTop: '选择上级',
  nothing: '无',
  sortNum: '排序',
  appType: '应用类型',
  appTypeTeching: '教学应用',
  appTypeStudy: '学习应用',
  appTypeManage: '管理应用',
  appTypeEvaluate: '评价应用',
  appTypeResearch: '教研应用',
  appTypeResource: '资源应用',
  appTypeOther: '其他应用',
  appTypeClass: '课堂应用',
  appTypeOtherTools: '授课工具',
  qsycdmc: '请输入菜单名称',
  qsrxh: '请输入序号',
  bccg: '保存成功',
  add: '新增',
  kfjk: '开放接口',
  common: '共',
  ssjg: '个搜索结果',
  mycxdjl: '没有查询到符合条件的记录',
  twtymyapi: '天闻统一门户平台API',
  twzjk: '天闻组件库',
  yhtx: '用户头像'
};

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 英文环境是否显示导航
   * @returns {boolean}
   */
  showTitle: function showTitle() {
    var lang = window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US';
    if (lang === 'en-US') {
      return false;
    }
    return true;
  },
  /**
   * 所有环境是否显示导航
   * @returns {boolean}
   */
  show: function show() {
    return false;
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tw_doc__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tw_doc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tw_doc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__web_doc_search__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__web_doc_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__web_doc_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web_doc_document_menu__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web_doc_document_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__web_doc_document_menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import URL from '../static/tools/baseurl'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      pageName: this.$store.state.pageName,
      minHeight: 0,
      dialogLogin: false,
      dialogLoginIn: false,
      org: '',
      orgList: [{
        value: '001',
        label: '机构1'
      }, {
        value: '选项002',
        label: '机构2'
      }]
    };
  },

  components: {
    Doc: __WEBPACK_IMPORTED_MODULE_0__components_tw_doc___default.a,
    twDocSearch: __WEBPACK_IMPORTED_MODULE_1__web_doc_search___default.a,
    dicMenu: __WEBPACK_IMPORTED_MODULE_2__web_doc_document_menu___default.a
  },
  mounted: function mounted() {
    this.minHeight = window.innerHeight - 120 + 'px';
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__web_doc_component__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__web_doc_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__web_doc_component__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activeId: '',
      defaultTreeProps: {
        children: 'children',
        label: 'menuName'
      },
      labelPosition: 0,
      getMenutype: 0,
      timer: null,
      appList: [],
      doc: {},
      jsLoadOver: false,
      menuList9th: [],
      tabName: ''
    };
  },
  mounted: function mounted() {
    this.getAppList();
  },

  methods: {
    activeAppName: function activeAppName() {
      return this.$store.state.typeOfAppList[0].appName || '';
    },
    changeDoc: function changeDoc(key, keyPat) {
      // console.log(key, 'key')
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$store.state.MenuList3th), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var a = _step.value;

          if (a.children === undefined || a.children.length === 0) {
            if (a.menuId === key.menuId) {
              if (a.menuClass === '4') {
                this.$store.commit('hasDoc', true);
                this.$store.commit('changeMenuId', key.menuId);
              }
            }
          } else if (a.children.length > 0) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(a.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var b = _step2.value;

                if (b.menuId === key.menuId) {
                  if (b.menuClass === '4') {
                    this.$store.commit('hasDoc', true);
                    this.$store.commit('changeMenuId', key.menuId);
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    filterApp: function filterApp(key) {
      var typeList = this.appList.filter(function (item) {
        return item.type === key;
      });
      this.$store.commit('changeTypeOfAppList', typeList);
      if (typeList.length > 0) {
        this.getAppMenuList({
          name: typeList[0].appId
        });
        // 现在
      }
    },
    getAppMenuList: function getAppMenuList(tab, event) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$store.state.typeOfAppList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var a = _step3.value;

          if (a.appId === tab.name) {
            this.getMenutype = 1;
            this.getDocMenu(a.appId);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    getDocMenu: function getDocMenu(id) {
      var _this = this;

      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        appId: id
      }).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          if (res.data && res.data.pageInfo && res.data.pageInfo.list && res.data.pageInfo.list.length > 0) {
            if (id) {
              var menuList3th = res.data.pageInfo.list.filter(function (item) {
                return item.menuClass === '3';
              });
              var menuList4th = [];
              if (menuList3th.length === 0) {
                menuList4th = res.data.pageInfo.list.filter(function (item) {
                  return item.menuClass === '4';
                });
                _this.$store.commit('changeMenuId', menuList4th[0].menuId);
              } else {
                menuList4th = _this.formatToTree(res.data.pageInfo.list, menuList3th[0].parentMenuId);
              }
              _this.$store.commit('changeMenuList3th', menuList4th);
              _this.$store.commit('hasDoc', true);
              _this.$store.commit('changeMenuId', menuList4th[0].children[0].menuId);
            }
          } else {
            _this.$store.commit('hasDoc', false);
            _this.$store.commit('changeMenuList3th', []);
            _this.$store.commit('changeMenuId', '');
          }
        } else {
          _this.$message.error(res.data.serverResult.resultMessage);
        }
      });
    },
    formatToTree: function formatToTree(ary, pid) {
      var _this2 = this;

      return ary.filter(function (item) {
        return (
          // 如果没有父id（第一次递归的时候）将所有父级查询出来
          // 这里认为 item.parentId === 0 就是最顶层 需要根据业务调整
          pid === undefined ? item.parentMenuId === '0' : item.parentMenuId === pid
        );
      }).map(function (item) {
        // 通过父节点ID查询所有子节点
        item.children = _this2.formatToTree(ary, item.menuId);
        return item;
      });
    },
    changeMenuList3th: function changeMenuList3th(_ref) {
      var _this3 = this;

      var name = _ref.name,
          index = _ref.index;

      this.getMenutype = 0;
      var Id = name;
      var appType = this.$store.state.MenuList2th[index].appType;
      console.log(name, index);
      this.$store.commit('changeActiveId2th', Id);
      if (this.$store.state.MenuList2th[0].parentMenuId === 'TWPAAS11000000004') {
        return this.filterApp(appType);
      }

      var data = [{
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: Id
      }, {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        appId: Id
      }];
      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', data[this.getMenutype]).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          if (res.data && res.data.pageInfo && res.data.pageInfo.list && res.data.pageInfo.list.length > 0) {
            _this3.$store.commit('hasDoc', true);
            if (Id) {
              var menuList3th = res.data.pageInfo.list.filter(function (item) {
                return item.menuClass === '3';
              });
              var menuList4th = _this3.formatToTree(res.data.pageInfo.list, menuList3th[0].parentMenuId);
              _this3.$store.commit('changeMenuList3th', menuList4th);
              // 非业务应用下
              if (menuList4th[0] && menuList4th[0].children && menuList4th[0].children.length > 0) {
                _this3.$store.commit('changeMenuId', menuList4th[0].children[0].menuId);
              } else {
                _this3.$store.commit('changeMenuId', menuList4th[0].menuId);
              }
            }
          } else {
            _this3.$store.commit('hasDoc', false);
            _this3.$message.error(res.data.serverResult.resultMessage);
          }
        }
      });
    },
    getAppList: function getAppList() {
      var _this4 = this;

      this.axios.post('/openapi-uc/app/list', {
        appId: '',
        numPerPage: 999,
        pageNum: 1,
        pageNo: 1,
        osType: '1',
        status: '6',
        userType: '1',
        appName: '',
        sectionId: '',
        subjectId: '',
        type: ''
      }).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          _this4.appList = res.data.pageInfo.list;
        } else {
          _this4.$message.warning('找不到app数据');
        }
      });
    }
  },
  components: {
    Editor: __WEBPACK_IMPORTED_MODULE_1__web_doc_component___default.a
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TwFooter'
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tw_lang__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tw_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tw_lang__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// let CryptoJS = require('crypto-js')
var headConfig = {
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TwHeader',
  components: { TwLang: __WEBPACK_IMPORTED_MODULE_3__tw_lang___default.a },
  data: function data() {
    return {
      routePath: '',
      activeMenuId: '',
      showDocMMneu: false,
      appList: [],
      appTypeDocList: [],
      menuList: [],
      showMenuLis: null,
      isShowMenuLis: false,
      orgName: '',
      username: '',
      minHeight: 0,
      showCaptcha: false,
      chooseOrg: false,
      autoLogin: false,
      dialogLogin: false,
      showUserImg: false,
      loginUser: null,
      passwd: null,
      userId: null,
      captcha: null,
      CAPTCHA_IMG: null,
      CAPTCHA_TEXT: null,
      orgList: [],
      hasUserOrg: true,
      user: {}
    };
  },

  computed: {
    orgNameShow: function orgNameShow() {
      var orgName = this.$i18n.messages[this.$i18n.locale].m.platform_name;
      var platformName = this.$store.state.systemConfig['paas_platform_name'];
      if (platformName) {
        document.title = platformName;
      } else {
        document.title = orgName;
      }
      if (this.$store.state.title && this.$store.state.title !== '' && this.$store.state.title != null && this.$store.state.title !== 'null') {
        orgName = this.$store.state.title;
      } else if (this.orgName && this.orgName !== '' && this.orgName !== null && this.orgName !== 'null' && this.orgName !== 'undefined') {
        orgName = this.orgName;
      } else if (platformName) {
        orgName = platformName;
      }
      return orgName;
    },
    orgLogo: function orgLogo() {
      var logoPath = './images/logo.png';
      // if (this.$store.state.systemConfig['paas_platform_logo_path']) {
      //   logoPath =
      //     this.$store.state.gateway_url +
      //     '/fs/media' +
      //     this.$store.state.systemConfig['paas_platform_logo_path']
      // }
      return logoPath;
    }
  },
  methods: {
    getQueryVariable: function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return false;
    },
    showLogin: function showLogin() {
      window.location.href = this.$store.state.login_url + '/tweb/pa/login.html';
    },
    getAppMenuList: function getAppMenuList(val) {
      this.activeAppName = val;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$store.state.typeOfAppList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var a = _step.value;

          if (a.appName === val) {
            this.getMenutype = 1;
            this.getDocMenu(a.appId);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    getDocMenu: function getDocMenu(id) {
      var _this = this;

      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        appId: id
      }).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          if (id) {
            var menuList3th = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '3';
            });
            var menuList4th = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '4';
            });
            menuList3th.map(function (item) {
              _this.$set(item, 'children', []);
              menuList4th.map(function (item1) {
                if (item.menuId === item1.parentMenuId) {
                  item.children.push(item1);
                }
              });
            });
            _this.$store.commit('changeMenuList3th', menuList3th);
          }
        } else {
          _this.$message.error(res.data.serverResult.resultMessage);
        }
      });
    },
    filterApp: function filterApp(key) {
      var typeList = this.appList.filter(function (item) {
        return item.type === key;
      });
      this.$store.commit('changeTypeOfAppList', typeList);
      this.getAppoflist(typeList[0].appId);
    },
    getAppList: function getAppList() {
      var _this2 = this;

      this.axios.post('/openapi-uc/app/list', {
        appId: '',
        numPerPage: 999,
        pageNum: 1,
        pageNo: 1,
        osType: '1',
        status: '6',
        userType: '1',
        appName: '',
        sectionId: '',
        subjectId: '',
        type: ''
      }).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          _this2.appList = res.data.pageInfo.list;
          var appType = __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('appType');
          var appId = __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('appID');
          _this2.axios.post('/openapi-uc/docMenu/queryDocMenuById/', {
            lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
            appId: appId
          }).then(function (res) {
            if (res.data.serverResult.resultCode === '200') {
              console.log('22222222222222222222222');
              if (res.data && res.data.pageInfo && res.data.pageInfo.list && res.data.pageInfo.list.length > 0) {
                if (appId) {
                  var menuList3th = res.data.pageInfo.list.filter(function (item) {
                    return item.menuClass === '3';
                  });
                  var menuList4th = [];
                  if (menuList3th.length === 0) {
                    menuList4th = res.data.pageInfo.list.filter(function (item) {
                      return item.menuClass === '4';
                    });
                  } else {
                    menuList4th = _this2.formatToTree(res.data.pageInfo.list, menuList3th[0].parentMenuId);
                  }

                  _this2.$store.commit('changeMenuList3th', menuList4th);
                  _this2.$store.commit('changeActiveAppId', appId);
                  _this2.$store.commit('changeMenuId', menuList4th[0].menuId);
                } else {
                  _this2.$store.commit('hasDoc', false);
                }
              } else {
                _this2.$store.commit('hasDoc', false);
                _this2.$store.commit('changeMenuList3th', []);
                _this2.$store.commit('changeMenuId', '');
              }
            } else {
              _this2.$message.error(res.data.serverResult.resultMessage);
            }
          });
          _this2.filterApp(appType || '1');
        } else {
          _this2.$message.warning('找不到app数据');
        }
      });
    },
    getAppoflist: function getAppoflist(appId) {
      var _this3 = this;

      var data = {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        appId: this.$store.state.typeOfAppList[0].appId
      };
      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', data).then(function (res) {
        if (res.data.serverResult.resultCode === '200' && res.data.pageInfo.list.length > 0) {
          if (appId) {
            var menuList = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '2';
            });
            if (menuList.length === 0) {
              var menuList3th = res.data.pageInfo.list.filter(function (item) {
                return item.menuClass === '3';
              });
              var menuList4th = _this3.formatToTree(res.data.pageInfo.list, menuList3th[0].parentMenuId);

              _this3.$store.commit('changeMenuList3th', menuList4th);
              if (_this3.$store.state.MenuList3th[0].menuClass === '3') {
                _this3.$store.commit('changeMenuId', menuList3th[0].children[0].menuId);
              } else {
                _this3.$store.commit('changeMenuId', menuList4th[0].menuId);
              }
            } else {
              _this3.$store.commit('changeMenuList2th', menuList);
            }
          } else {
            var _menuList = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '1';
            });
            var tempArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_menuList));
            _this3.menuList = tempArr;
            _this3.getMenuList(_menuList[0].menuId);
          }
        } else {
          _this3.$store.commit('changeMenuList3th', []);
        }
      });
    },
    formatToTree: function formatToTree(ary, pid) {
      var _this4 = this;

      return ary.filter(function (item) {
        return (
          // 如果没有父id（第一次递归的时候）将所有父级查询出来
          // 这里认为 item.parentId === 0 就是最顶层 需要根据业务调整
          pid === undefined ? item.parentMenuId === '0' : item.parentMenuId === pid
        );
      }).map(function (item) {
        // 通过父节点ID查询所有子节点
        item.children = _this4.formatToTree(ary, item.menuId);
        return item;
      });
    },

    // 路由导航
    routerTo: function routerTo(data) {
      var _this5 = this;

      var path = __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('routePath');
      if (path === null || path === '/introduce/scene') {
        this.getMenuList(this.menuList[0].menuId);
      } else {
        var _loop = function _loop(a) {
          if (a.menuPath === path) {
            if (path === '/integrate/faq/apiQuestion') {
              _this5.getMenuList('TWPAAS11000000002');
              setTimeout(function () {
                _this5.$store.commit('changeActiveId2th', 'TWPAAS11000000010');
                _this5.getMenu3THList('TWPAAS11000000010');
              }, 200);
            } else if (path === '/integrate/quick/account') {
              _this5.getMenuList('TWPAAS11000000002');
            } else if (path === '/integrate/api/readme') {
              _this5.getMenuList('TWPAAS11000000002');
              setTimeout(function () {
                _this5.$store.commit('changeActiveId2th', 'TWPAAS11000000009');
                _this5.getMenu3THList('TWPAAS11000000009');
              }, 200);
            }
            setTimeout(function () {
              _this5.$store.commit('changeMenuId', a.menuId);
            }, 400);
            __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('nowMenuId', a.menuId);
          }
        };

        //
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var a = _step2.value;

            _loop(a);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    },
    getMenu3THList: function getMenu3THList(menuId) {
      var _this6 = this;

      this.activeMenuId = menuId;
      var data = {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: menuId
      };
      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', data).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          if (menuId) {
            var menuList3th = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '3';
            });
            var menuList4th = [];
            if (menuList3th.length === 0) {
              menuList4th = res.data.pageInfo.list.filter(function (item) {
                return item.menuClass === '4';
              });
            } else {
              menuList4th = _this6.formatToTree(res.data.pageInfo.list, menuList3th[0].parentMenuId);
            }
            _this6.$store.commit('changeMenuList3th', menuList4th);
          }
        } else {
          _this6.$message.error(res.data.serverResult.resultMessage);
        }
      });
    },
    getMenuList: function getMenuList(menuId) {
      var _this7 = this;

      this.showMenuLis = null;
      this.activeMenuId = menuId;
      var data = {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: menuId
      };
      if (menuId === 'TWPAAS11000000004') {
        this.getAppList();
      }
      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', data).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          _this7.$store.commit('changePageName', 'Doc');
          _this7.$store.commit('changeMenuList2th', []);
          _this7.$store.commit('changeTypeOfAppList', []);
          if (menuId) {
            var menuList = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '2';
            });
            if (menuList.length > 0) {
              _this7.$store.commit('changeActiveId2th', menuList[0].menuId);
            }
            if (menuList.length === 0) {
              var menuList3th = res.data.pageInfo.list.filter(function (item) {
                return item.menuClass === '3';
              });
              var menuList4th = [];
              if (menuList3th.length === 0) {
                menuList4th = res.data.pageInfo.list.filter(function (item) {
                  return item.menuClass === '4';
                });
              } else {
                menuList4th = _this7.formatToTree(res.data.pageInfo.list, menuList3th[0].parentMenuId);
              }
              _this7.$store.commit('changeMenuList3th', menuList4th);
              // 默认打开第一个选项
              if (_this7.$store.state.MenuList3th[0] && _this7.$store.state.MenuList3th[0].menuClass === '3') {
                _this7.$store.commit('changeMenuId', menuList4th[0].children[0].menuId);
                _this7.$store.commit('hasDoc', true);
              } else {
                _this7.$store.commit('changeMenuId', menuList4th[0].menuId);
                _this7.$store.commit('hasDoc', true);
              }
            } else {
              _this7.$store.commit('changeMenuList2th', menuList);
              _this7.getMenu3THList(menuId);
              _this7.$store.commit('changeMenuId', menuList[0].menuId);
              _this7.$store.commit('hasDoc', true);
            }
          } else {
            var _menuList2 = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '1';
            });
            var tempArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_menuList2));
            _this7.menuList = tempArr;
            _this7.routerTo(res.data.pageInfo.list);
          }
          _this7.showMenuLis = setTimeout(function () {
            _this7.isShowMenuLis = true;
            clearTimeout(_this7.showMenuLis);
          }, 200);
        } else {
          _this7.$message.error(res.data.serverResult.resultMessage);
        }
      });
    },
    classification: function classification() {
      var appTypeList = [];
      if (this.$store.state.MenuList2th.length > 0) {
        var type = this.$store.state.MenuList2th[0].appType;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.appTypeDocList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var a = _step3.value;

            if (a.type = type) {
              appTypeList.push(a);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    },
    getMenuList3th: function getMenuList3th(menuId) {
      var _this8 = this;

      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: menuId
      }).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          if (menuId) {
            var menuList3th = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '3';
            });
            var menuList4th = res.data.pageInfo.list.filter(function (item) {
              return item.menuClass === '4';
            });
            menuList3th.map(function (item) {
              _this8.$set(item, 'children', []);
              menuList4th.map(function (item1) {
                if (item.menuId === item1.parentMenuId) {
                  item.children.push(item1);
                }
              });
            });
            _this8.$store.commit('hasDoc', true);
            _this8.$store.commit('changeMenuList3th', menuList3th);
            _this8.$store.commit('changeMenuId', menuList3th[0].children[0].menuId);
          }
        } else {
          _this8.$message.error(res.data.serverResult.resultMessage);
        }
      });
    },
    goto: function goto() {
      this.$store.commit('changePageName', 'dicMenu');
    },
    jumpTo: function jumpTo(index) {
      var linkList = ['http://192.168.102.109:7780/unified-portal/doc.html#/default/', 'http://192.168.112.179:83/#/doc/comps/poppane'];
      window.open(linkList[index]);
    },

    showUserImage: function showUserImage() {
      var vm = this;
      vm.orgName = __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('CURRENT_ORG_NAME');
      vm.username = __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('CURRENT_LOGIN_NAME');
      vm.showUserImg = true;
    },
    isIEBelow9: function isIEBelow9() {
      var userAgent = navigator.userAgent;
      var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
      var isEdge = userAgent.indexOf('Edge') > -1 && !isIE;
      var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
      if (isIE) {
        var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp['$1']);
        if (fIEVersion === 7) {
          return true;
        } else if (fIEVersion === 8) {
          return true;
        } else if (fIEVersion === 9) {
          return true;
        } else if (fIEVersion === 10) {
          return false;
        } else {
          return true;
        }
      } else if (isEdge) {
        return false;
      } else if (isIE11) {
        return false;
      } else {
        // 非 IE 浏览器
        return false;
      }
    },
    getUserToLogin: function getUserToLogin(accessToken) {
      var vm = this;
      var state = vm.$store.state;
      var loginUser = vm.user;
      this.axios.get('/openapi-uc/uc/getUserByToken/' + accessToken).then(function (response) {
        var user = response.data.responseEntity;
        console.log(user, 57111);
        if (user) {
          if (user.user2OrgList && user.user2OrgList.length > 0) {
            var tenantId = user.user2OrgList[0].tenantId;
            state.tenantId = tenantId;
            __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('CURRENT_TENANT_ID', tenantId);
          }
          state.roleIdList = user.roleIdList;
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('CURRENT_ROLE_ID_LIST', user.roleIdList);
          var onepicelist = ['1000000002', '1000000003', '1000000004', '1000000008', '10000000030'];
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(onepicelist), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var a = _step4.value;
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(user.roleIdList), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var b = _step5.value;

                  if (a === b) {
                    __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('CURRENT_ROLE_ID', b);
                  }
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          state.userId = user.userId;
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('Current_User_Id', user.userId);
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('X-User-Account', user.userId);
          state.userName = user.realName;
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('CURRENT_LOGIN_NAME', user.realName);
          state.orgId = user.orgId;
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('Current-Org-Id', user.orgId);
          state.orgName = user.orgName;
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('CURRENT_ORG_NAME', user.orgName);
          loginUser.userId = state.userId;
          loginUser.userName = state.userName;
          loginUser.orgId = state.orgId;
          loginUser.orgName = state.orgName;
          vm.showUserImage();
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
          // 加路由
        }
        vm.dialogLogin = false;
        window.location.href = '';
      }).catch(function (error) {
        vm.showCaptcha = true;
        vm.$message({
          message: error,
          type: 'error'
        });
      });
    },
    userLogin: function userLogin() {
      var vm = this;
      var accessToken = this.$route.query.access_token;
      var accreditCode = this.$route.query.accredit_code;
      var userRoleIdList = [];
      if (__WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('CURRENT_ROLE_ID_LIST') !== null) {
        userRoleIdList = __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('CURRENT_ROLE_ID_LIST');
        if (userRoleIdList.indexOf('1000000001') >= 0) {
          vm.showDocMMneu = true;
        } else {
          vm.showDocMMneu = false;
        }
      }
      if (this.$route.path !== '/') {
        vm.routePath = this.$route.path;
        __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('routePath', this.$route.path);
      }

      if (accessToken === undefined || accreditCode === undefined) {
        return;
      }
      // let appInfo = {}
      var loginParam = 'client_id=50f104a9932e412cba81a0224d78bc92&client_secret=' + vm.$store.state.client_secret + '&grant_type=client_credentials&accredit_code=' + accreditCode + '&access_token=' + accessToken;
      vm.axios.post('/openapi-uc/oauth/token?' + loginParam, {}, headConfig).then(function (response) {
        if (response.data.resultCode === '8006') {
          vm.weakPwdFlag = true;
          vm.$store.commit('weakPwdFlag', true);
          __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('weakPwdFlag', true);
        }
        var accessToken = response.data.access_token;
        __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('Access-Token', accessToken);
        vm.getUserToLogin(accessToken);
      }).catch(function (error) {
        var msg = null;
        if (error.errorCode === 8005) {
          vm.orgList = [];
          vm.userId = null;
          var userList = error.userList != null ? error.userList : error.exception.userList;
          for (var i = 0; i < userList.length; i++) {
            var u = userList[i];
            if (u.userId.startsWith('CJTWBS1')) {
              continue;
            }
            var orgObject = {};
            var roleName = '';
            var orgName = '';
            var realName = '';
            if (u.roleName) {
              roleName = u.roleName;
            }
            if (u.orgName) {
              orgName = u.orgName;
            }
            if (u.realName) {
              realName = u.realName;
            }

            orgObject.orgUserName = orgName + '(' + realName + roleName + ')';
            orgObject.userId = u.userId;
            vm.orgList.push(orgObject);
            if (i === 0) {
              vm.userId = u.userId;
              vm.username = realName;
            }
          }
          if (vm.orgList.length === 1) {
            vm.userId = vm.orgList[0].userId;
            vm.login();
            return;
          }
          vm.chooseOrg = true;
          msg = vm.$i18n.messages[vm.$i18n.locale].m.loginNameRepeatTip;
        } else if (error.errorCode === 8001) {
          msg = vm.$i18n.messages[vm.$i18n.locale].m.userStatusNotCorrectTip;
        } else if (error.errorCode === 8002) {
          msg = vm.$i18n.messages[vm.$i18n.locale].m.userNotExistTip;
        } else if (error.errorCode === 8004) {
          msg = error.errorMesage;
        } else if (error.errorCode === 8007) {
          msg = error.errorMesage;
        } else if (error.errorCode === 8000) {
          msg = error.errorMesage;
        } else if (error.errorCode === 70008) {
          msg = error.errorMesage;
        } else {
          msg = vm.$i18n.messages[vm.$i18n.locale].m.loginFailed;
        }
        vm.$message({
          message: msg,
          type: 'error'
        });
      });
    },
    logout: function logout() {
      var vm = this;
      var state = vm.$store.state;
      state.token = '';
      state.tenantId = '';
      state.userId = '';
      state.userName = '';
      state.orgId = '';
      state.orgName = '';
      state.lang = '';
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('Access-Token');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('CURRENT_TENANT_ID');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('CURRENT_ROLE_ID_LIST');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('Current_User_Id');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('CURRENT_LOGIN_NAME');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('Current-Org-Id');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('CURRENT_ORG_NAME');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('SWITCH_LANG');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('routePath');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('appID');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].delete('appType');
      vm.showUserImg = false;
      var currentUrl = window.location.href;
      var index = currentUrl.indexOf('?');
      if (index >= 0) {
        currentUrl = currentUrl.substr(0, index);
      }
      this.$router.go(0);
      state.editor.isAdmin = false;
      state.editor.isEditing = false;
      window.location.href = currentUrl;
    }
  },
  created: function created() {
    var vm = this;
    var userId = __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('Current_User_Id');
    if (userId) {
      vm.showUserImage();
    }
    vm.axios.post('/openapi-uc/system/platConfig', {}).then(function (success) {
      if (success.data && success.data.pageInfo && success.data.pageInfo.list) {
        var list = success.data.pageInfo.list;
        var systemConfigMap = {};
        list.forEach(function (item) {
          if (item.value) {
            systemConfigMap[item.key] = item.value;
          }
        });
        vm.$store.commit('systemConfig', systemConfigMap);
      }
    }).catch(function (error) {
      vm.$message({
        message: error.data.serverResult.resultMessage,
        type: 'error'
      });
    });
    this.getMenuList('');
  },
  mounted: function mounted() {
    var _this9 = this;

    var appType = this.$route.query.apptype || this.$route.query.appType;
    var appId = this.$route.query.appid || this.$route.query.appId;
    if (appType !== undefined && appId !== undefined) {
      console.log(appType, appId, 'appType');
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('appID', appId);
      __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].set('appType', appType);
    }
    this.userLogin();
    setTimeout(function () {
      if (__WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('appID') !== null && __WEBPACK_IMPORTED_MODULE_2__config_cookieUtils__["a" /* default */].get('appType') !== null) {
        _this9.getMenuList('TWPAAS11000000004');
      }
    }, 500);
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_cookieUtils__ = __webpack_require__(43);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TwLang',
  data: function data() {
    return {
      currentLangText: '',
      lang: 'zh_CN',
      langOpen: 'on'
    };
  },

  created: function created() {
    this.initLang();
  },
  methods: {
    // 初始化语言
    initLang: function initLang() {
      var vm = this;
      vm.lang = window.localStorage.getItem('tw_i18n_local') || 'zh_CN';
      if (vm.lang === 'en_US') {
        vm.currentLangText = '中文';
      } else {
        vm.currentLangText = 'English';
      }
      console.log(vm.lang);
      vm.$i18n.locale = vm.lang; // 关键语句
    },
    changeLangEvent: function changeLangEvent(language) {
      var _this = this;

      this.$confirm(this.$i18n.messages[this.$i18n.locale].m.changeLangConfirm, this.$i18n.messages[this.$i18n.locale].m.commonTip, {
        confirmButtonText: this.$i18n.messages[this.$i18n.locale].m.confirmText,
        cancelButtonText: this.$i18n.messages[this.$i18n.locale].m.cancel,
        type: 'warning'
      }).then(function () {
        // 切换语言
        _this.lang = language;
        console.log(_this.lang);
        window.localStorage.setItem('tw_i18n_local', _this.lang);
        _this.$i18n.locale = _this.lang; // 关键语句
        if (_this.lang === 'en-US') {
          _this.currentLangText = 'English';
          _this.$store.state.lang = 'en-US';
        } else {
          _this.currentLangText = '中文';
          _this.$store.state.lang = 'zh-CN';
        }
        __WEBPACK_IMPORTED_MODULE_0__config_cookieUtils__["a" /* default */].set('SWITCH_LANG', true);
        window.location.href = '';
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: _this.$i18n.messages[_this.$i18n.locale].m.cancelManual
        });
      });
    }
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scriptjs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_editor_md__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_cookieUtils__ = __webpack_require__(43);




//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    editorId: {
      type: String,
      default: 'markdown-editor'
    },
    onchange: {
      // 内容改变时回调，返回（html, markdown, text）
      type: Function
    },
    config: {
      // 编辑器配置
      type: Object
    },
    initData: {
      type: String
    },
    initDataDelay: {
      type: Number, // 延迟初始化数据时间，单位毫秒
      default: 0
    }
  },
  data: function data() {
    return {
      editor: null,
      timer: null,
      doc: {},
      jsLoadOver: false
    };
  },
  methods: {
    fetchScript: function fetchScript(url) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_4_scriptjs___default()(url, function () {
          resolve();
        });
      });
    },
    getConfig: function getConfig() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__config_editor_md__["a" /* defaultConfig */], this.config);
    },
    getEditor: function getEditor() {
      return this.editor;
    },
    getDoc: function getDoc() {
      return this.doc;
    },
    watch: function watch() {
      return this.editor.watch();
    },
    unwatch: function unwatch() {
      return this.editor.unwatch();
    },
    previewing: function previewing() {
      return this.editor.previewing();
    },
    getHTML: function getHTML() {
      return this.editor.getHTML();
    },
    getMarkdown: function getMarkdown() {
      return this.editor.getMarkdown();
    },
    setMarkdown: function setMarkdown(markdown) {
      return this.editor.setMarkdown(markdown);
    },
    init: function init(id) {
      var vm = this;
      var editor = vm.$store.state.editor;
      if (editor.goEdit) {
        editor.goEdit = false;
      } else {
        editor.isEditing = false;
      }
      vm.axios.get('/openapi-uc/doc/getDocById/' + id).then(function (response) {
        var doc = response.data.pageInfo.list[0];
        vm.doc = doc;
        var md = doc.content;
        vm.initEditor(md);
      }).catch(function (error) {
        vm.$message({
          message: error.data.serverResult.resultMessage,
          type: 'error'
        });
      });
    },

    initEditor: function initEditor(markdown) {
      var _this = this;

      var vm = this;
      var config = vm.getConfig();
      if (markdown) {
        config.markdown = markdown;
      }
      ;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return vm.fetchScript('./editor.md/jquery.min.js');

              case 2:
                _context.next = 4;
                return _this.fetchScript('./editor.md/jquery-migrate-3.4.0.js');

              case 4:
                _context.next = 6;
                return vm.fetchScript('./editor.md/editormd.min.js');

              case 6:
                vm.jsLoadOver = true;
                vm.$nextTick(function () {
                  vm.editor = window.editormd(vm.editorId, config);
                  vm.editor.on('load', function () {
                    setTimeout(function () {
                      // hack bug: 一个页面多个编辑器只能初始化其中一个数据问题
                      vm.initData && vm.editor.setMarkdown(vm.initData);
                    }, vm.initDataDelay);
                  });
                  vm.onchange && vm.editor.on('change', function () {
                    var html = vm.editor.getPreviewedHTML();
                    vm.onchange({
                      markdown: vm.editor.getMarkdown(),
                      html: html,
                      text: window.$(html).text()
                    });
                  });
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var vm = this;
    var docId = vm.$store.state.MenuId === '' ? __WEBPACK_IMPORTED_MODULE_6__config_cookieUtils__["a" /* default */].get('nowMenuId') : vm.$store.state.MenuId;
    vm.init(docId);
    vm.timer = setInterval(function () {
      if (vm.editor && vm.jsLoadOver) {
        try {
          vm.watch();
          vm.previewing();
          vm.previewing();
          window.clearInterval(vm.timer);
          vm.timer = null;
        } catch (e) {}
      }
    }, 80);
  },
  destroyed: function destroyed() {
    var vm = this;
    if (vm.timer != null) {
      window.clearInterval(vm.timer);
      vm.timer = null;
    }
  }
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scriptjs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_cookieUtils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_editor_md__ = __webpack_require__(154);




//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    viewId: {
      type: String,
      default: 'markdown-view'
    },
    config: {
      // 编辑器配置
      type: Object
    },
    initData: {
      type: String
    },
    initDataDelay: {
      type: Number, // 延迟初始化数据时间，单位毫秒
      default: 0
    }
  },
  data: function data() {
    return {
      doc: {},
      editor: null
    };
  },
  methods: {
    fetchScript: function fetchScript(url) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_4_scriptjs___default()(url, function () {
          resolve();
        });
      });
    },
    getDoc: function getDoc() {
      return this.doc;
    },
    getConfig: function getConfig() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6__config_editor_md__["a" /* defaultConfig */], this.config);
    },
    forceUpdate: function forceUpdate() {
      this.$forceUpdate();
    },
    initView: function initView() {
      var _this = this;

      ;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchScript('./editor.md/jquery.min.js');

              case 2:
                _context.next = 4;
                return _this.fetchScript('./editor.md/jquery-migrate-3.4.0.js');

              case 4:
                _context.next = 6;
                return _this.fetchScript('./editor.md/lib/marked.min.js');

              case 6:
                _context.next = 8;
                return _this.fetchScript('./editor.md/lib/prettify.min.js');

              case 8:
                _context.next = 10;
                return _this.fetchScript('./editor.md/lib/raphael.min.js');

              case 10:
                _context.next = 12;
                return _this.fetchScript('./editor.md/lib/underscore.min.js');

              case 12:
                _context.next = 14;
                return _this.fetchScript('./editor.md/lib/sequence-diagram.min.js');

              case 14:
                _context.next = 16;
                return _this.fetchScript('./editor.md/lib/flowchart.min.js');

              case 16:
                _context.next = 18;
                return _this.fetchScript('./editor.md/lib/jquery.flowchart.min.js');

              case 18:
                _context.next = 20;
                return _this.fetchScript('./editor.md/editormd.min.js');

              case 20:
                // console.log(this.viewId, this.getConfig(), 'this.viewId')
                _this.$nextTick(function () {
                  _this.editor = window.editormd.markdownToHTML(_this.viewId, _this.getConfig());
                });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setDoc: function setDoc(doc) {
      if (doc) {
        var vm = this;
        vm.doc = doc;
        var markdownViewDiv = document.getElementById('markdown-view');
        if (markdownViewDiv) {
          markdownViewDiv.innerHTML = '<textarea style="display: none;"></textarea>';
          vm.initView();
          if (doc.content) {
            markdownViewDiv.getElementsByTagName('textarea')[0].innerHTML = doc.content;
          }
        }
      }
    },
    showContent: function showContent(id) {
      var vm = this;
      if (id === '' || id === undefined || id.length === 0) {
        return;
      }
      vm.$store.state.editor.isEditing = false;
      vm.axios.get('/openapi-uc/doc/getDocById/' + id).then(function (response) {
        if (response.data && response.data.pageInfo && response.data.pageInfo.list && response.data.pageInfo.list.length > 0) {
          vm.$store.commit('hasDoc', true);
          var doc = response.data.pageInfo.list[0];
          if (doc) {
            vm.doc = doc;
            var markdownViewDiv = document.getElementById('markdown-view');
            if (markdownViewDiv) {
              markdownViewDiv.innerHTML = '<textarea style="display: none;"></textarea>';
              vm.initView();
              if (doc.content) {
                markdownViewDiv.getElementsByTagName('textarea')[0].innerHTML = doc.content;
              }
            }
          } else {
            vm.$store.commit('hasDoc', false);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var vm = this;
    var docId = '';
    docId = vm.$store.state.MenuId === '' ? __WEBPACK_IMPORTED_MODULE_5__config_cookieUtils__["a" /* default */].get('nowMenuId') : vm.$store.state.MenuId;
    vm.showContent(docId);
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'twTotop',
  data: function data() {
    return {
      visible: false
    };
  },
  methods: {
    scrollHandler: function scrollHandler() {
      var scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 300) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
    toTopHandler: function toTopHandler() {
      var scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var distance = scrollTop / 30;

      var toScroll = function toScroll() {
        scrollTop -= distance;
        window.scrollTo(0, scrollTop);

        if (scrollTop < 0) {
          return;
        } else {
          setTimeout(toScroll, 10);
        }
      };

      setTimeout(toScroll, 10);
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  dostroyed: function dostroyed() {
    window.removeEventListener('scroll', this.scrollHandler);
  }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_router__ = __webpack_require__(161);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tw404',
  data: function data() {
    return {
      minHeight: 0
    };
  },

  methods: {
    backPrevPage: function backPrevPage() {
      __WEBPACK_IMPORTED_MODULE_0__config_router__["a" /* default */].go(-1);
    }
  },
  mounted: function mounted() {
    this.minHeight = window.innerHeight - 180 + 'px';
  }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tw_markdown_editor__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tw_markdown_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tw_markdown_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tw_markdown_view__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tw_markdown_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tw_markdown_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_cookieUtils__ = __webpack_require__(43);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { util } from 'vue/types/umd'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'twMarkdown',
  components: { TwMarkdownEditor: __WEBPACK_IMPORTED_MODULE_3__components_tw_markdown_editor___default.a, TwMarkdownView: __WEBPACK_IMPORTED_MODULE_4__components_tw_markdown_view___default.a },
  data: function data() {
    return {
      file_upload_server: this.$store.state.gateway_url + '/fs/fs/file/upload',
      headerObj: {
        'Access-Token': this.$store.state.token
      },
      fileType: 'image/jpeg,mage/jpg,image/gif,image/png,image/bmp,video/mp4,video/avi,doc,docx,xls,xlsx,ppt,pptx',
      uploadData: {
        branchCode: this.$store.state.tenantId ? this.$store.state.tenantId : 'PAAS01'
      },
      doc: {},
      titleTimer: null,
      editor: this.$store.state.editor
    };
  },
  methods: {
    cancelSave: function cancelSave() {
      this.editor.isEditing = !this.editor.isEditing;
    },
    toSearch: function toSearch() {
      var vm = this;
      if (vm.$store.state.searchKey) {
        this.$store.commit('changePageName', 'twDocSearch');
      }
      console.log(this.$store.state.pageName);
    },
    beforeUpload: function beforeUpload(file) {
      // var fileName = file.name
      // if (this._.trim(fileName) === '' ||
      //   !this._.endsWith(fileName, '.xls')) {
      //   this.$message.error(this.$i18n.messages[this.$i18n.locale].m.selectCorrctExcelFile)
      //   return false
      // }
      // alert(1)
    },

    uploadFail: function uploadFail(err) {
      console.log(err);
      this.$message.error('上传文件失败');
    },
    //  上传成功
    uploadSuccess: function uploadSuccess(rep) {
      if (rep.fileInfos != null && rep.fileInfos.length > 0) {
        var vm = this;
        var filePath = rep.fileInfos[0].localPath;
        if (filePath) {
          var fileUrl = vm.$store.state.gateway_url + '/fs/media' + filePath;
          var mdUrl = null;
          var markdown = vm.$refs['markdown'];
          if (vm.isImage(filePath)) {
            mdUrl = '![](' + fileUrl + ')';
          } else if (vm.isVideo(filePath)) {
            mdUrl = '<video src="' + fileUrl + '" controls="controls" width="500" height="300">\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u64AD\u653E\u8BE5\u6587\u4EF6\uFF01</video>';
          } else {
            mdUrl = fileUrl;
          }
          var newMd = markdown.getMarkdown() + '\n' + mdUrl;
          markdown.setMarkdown(newMd);
          markdown.watch();
        }
      }
    },
    isImage: function isImage(filePath) {
      if (this._.endsWith(filePath, '.jpg') || this._.endsWith(filePath, '.jpeg') || this._.endsWith(filePath, '.png') || this._.endsWith(filePath, '.bmp') || this._.endsWith(filePath, '.gif')) {
        return true;
      }
      return false;
    },
    isVideo: function isVideo(filePath) {
      if (this._.endsWith(filePath, '.mp4') || this._.endsWith(filePath, '.avi') || this._.endsWith(filePath, '.wmv') || this._.endsWith(filePath, '.m4v')) {
        return true;
      }
      return false;
    },
    editorDoc: function editorDoc() {
      var vm = this;
      vm.toggleEdit();
    },
    toggleEdit: function toggleEdit() {
      this.editor.goEdit = true;
      this.editor.isEditing = !this.editor.isEditing;
    },
    saveDoc: function saveDoc() {
      var vm = this;
      var markdown = vm.$refs['markdown'];
      var md = markdown.getMarkdown();
      var doc = vm.doc;
      doc.content = md;
      vm.axios.post('/openapi-uc/doc/updateDocument', vm.doc).then(function (response) {
        vm.toggleEdit();
      }).catch(function (error) {
        vm.$message({
          message: error.data.serverResult.resultMessage,
          type: 'error'
        });
        console.log(error);
      });
    },
    setViewDoc: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var vm, markdownView;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = this;
                markdownView = vm.$refs['markdownView'];

                if (!(id === '' || id === undefined || id.length === 0)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                vm.axios.get('/openapi-uc/doc/getDocById/' + id).then(function (response) {
                  vm.doc = response.data.pageInfo.list[0];
                  try {
                    markdownView.setDoc(vm.doc);
                  } catch (e) {
                    console.log(e);
                  }
                }).catch(function (error) {
                  vm.$message({
                    message: error.data.serverResult.resultMessage,
                    type: 'error'
                  });
                  console.log(error);
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setViewDoc(_x) {
        return _ref.apply(this, arguments);
      }

      return setViewDoc;
    }(),
    getIsAdmin: function getIsAdmin() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$store.state.MenuList3th), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var a = _step.value;

          if (a.children && a.children.length > 0) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(a.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var b = _step2.value;

                if (b.creatorId === __WEBPACK_IMPORTED_MODULE_5__config_cookieUtils__["a" /* default */].get('Current_User_Id')) {
                  this.$store.commit('areYouAdmin', true);
                } else {
                  this.$store.commit('areYouAdmin', false);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            if (a.creatorId === __WEBPACK_IMPORTED_MODULE_5__config_cookieUtils__["a" /* default */].get('Current_User_Id')) {
              this.$store.commit('areYouAdmin', true);
            } else {
              this.$store.commit('areYouAdmin', false);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  // 改版关键
  watch: {
    MenuId: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        this.$nextTick(function () {
          _this.setViewDoc(val);
        });
        if (this.editor.isEditing) {
          this.cancelSave();
        }
        this.getIsAdmin();
      }
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.titleTimer = setInterval(function () {
      if (!vm.doc || !vm.doc.title) {
        var markdownView = vm.$refs['markdownView'];
        if (markdownView) {
          var doc = markdownView.getDoc();
          if (doc) {
            vm.doc = doc;
            if (vm.doc.docTitle) {
              var roleIdList = __WEBPACK_IMPORTED_MODULE_5__config_cookieUtils__["a" /* default */].get('CURRENT_ROLE_ID_LIST');
              if (roleIdList && roleIdList.length > 0) {
                if (roleIdList.indexOf('1000000001') >= 0 || roleIdList.indexOf('1000000005') >= 0) {
                  vm.editor.isAdmin = true;
                } else {
                  vm.editor.isAdmin = false;
                }
              } else {
                vm.editor.isAdmin = false;
              }
              window.clearInterval(vm.titleTimer);
              vm.titleTimer = null;
            }
          }
        }
      } else {
        window.clearInterval(vm.titleTimer);
        vm.titleTimer = null;
      }
    }, 80);
  },
  computed: {
    MenuId: function MenuId() {
      return this.$store.state.MenuId;
    }
  },
  destroyed: function destroyed() {
    var vm = this;
    if (vm.titleTimer != null) {
      window.clearInterval(vm.titleTimer);
      vm.titleTimer = null;
    }
  }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_webBase__ = __webpack_require__(281);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      canSave: false,
      newForm: {},
      // 1-教学应用； 2-学习应用；3-管理应用；4-评价应用；5-教研应用；6-其他应用;8-课堂应用；9-授课工具
      appTypes: [{
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeTeching,
        val: '1'
      }, {
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeStudy,
        val: '2'
      }, {
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeManage,
        val: '3'
      }, {
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeEvaluate,
        val: '4'
      }, {
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeResearch,
        val: '5'
      }, {
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeOthe,
        val: '6'
      }, {
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeClass,
        val: '8'
      }, {
        label: this.$i18n.messages[this.$i18n.locale].m.appTypeOtherTools,
        val: '9'
      }],
      newflag: false,
      devTreeDefaultProps: {
        children: 'children',
        label: 'menuName'
      },
      // 开发树节点: 默认展开的节点索引
      devTreeExpandedKeys: ['1'],

      // 弹出菜单节点上下文
      devTreeMenuContext: {
        data: null,
        node: null
      },
      devTreeData: [],
      ruleForm: {},
      rules: {
        menuName: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        sortNum: [{ required: true, message: '请输入序号', trigger: 'blur' }]
      },
      showTitle: __WEBPACK_IMPORTED_MODULE_0__utils_webBase__["a" /* default */].showTitle()
    };
  },

  mounted: function mounted() {
    this.getMenuList();
  },
  methods: {
    updateDocMenu: function updateDocMenu() {
      var _this = this;

      this.axios.post('/openapi-uc/updateDocMenu', this.ruleForm).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          _this.$message.success('保存成功');
        }
      });
    },
    setMenuInfo: function setMenuInfo(val) {
      if (val.parentMenuId === 'TWPAAS11000000004') {
        this.canSave = true;
      } else {
        this.canSave = false;
      }
      this.ruleForm = val;
      this.newflag = false;
    },
    renderTreePopBtn: function renderTreePopBtn(h, _ref) {
      var _this2 = this;

      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      return h('span', [h('span', [node.label]), h(
        'span',
        {
          style: {
            float: 'right'
          }
        },
        [data.menuId === 'TWPAAS11000000004' && h('i', {
          'class': 'el-icon-plus',
          style: {
            color: '#0b87f4',
            marginRight: '10px'
          },
          on: {
            'click': function click() {
              return _this2.newDocMenu(data);
            }
          }
        }), data.parentMenuId === 'TWPAAS11000000004' && data.menuClass === '2' && h('i', {
          'class': 'el-icon-delete',
          style: {
            color: '#0b87f4',
            marginRight: '10px'
          },
          on: {
            'click': function click() {
              return _this2.deleteDocMenuById(data);
            }
          }
        })]
      )]);
    },
    newDocMenu: function newDocMenu(v) {
      this.newflag = true;
      this.newForm = {
        appType: '',
        createTime: '2019-01-09 10:13:21',
        creatorId: 'PAAS00110000000',
        initMenu: '1',
        lang: 'zh_CN',
        menuClass: '2',
        menuName: '',
        menuPath: '',
        parentMenuId: 'TWPAAS11000000004',
        sortNum: 0
      };
    },
    deleteDocMenuById: function deleteDocMenuById(v) {
      var _this3 = this;

      this.$confirm('\u786E\u5B9A\u8981\u5220\u9664' + v.menuName + '?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.axios.post('/openapi-uc/deleteDocMenuById', v.menuId).then(function (res) {
          if (res.data.serverResult.resultCode === '200') {
            _this3.$message({
              type: 'warning',
              message: '\u5220\u9664\u6210\u529F'
            });
            _this3.getMenuList();
          }
        });
      });
    },
    addDocument: function addDocument() {
      var _this4 = this;

      this.axios.post('/openapi-uc/docMenu/addDocMenu', this.newForm).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          _this4.$message({
            type: 'success',
            message: '\u6DFB\u52A0\u6210\u529F'
          });
          _this4.newflag = false;
          _this4.getMenuList();
        }
      });
    },
    getMenuList: function getMenuList(menuId) {
      var _this5 = this;

      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: menuId
      }).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          var menuList = res.data.pageInfo.list.filter(function (item) {
            return item.menuClass === '1';
          });
          var menuList1 = res.data.pageInfo.list.filter(function (item) {
            return item.menuClass === '2' || item.menuClass === '3';
          });
          menuList.map(function (item) {
            _this5.$set(item, 'children', []);
            menuList1.map(function (item1) {
              if (item.menuId === item1.parentMenuId) {
                item.children.push(item1);
              }
            });
          });
          _this5.devTreeData = menuList;
        } else {
          _this5.$message.error(res.data.serverResult.resultMessage);
        }
      });
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_cookieUtils__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'twMarkdown',
  data: function data() {
    return {
      documentList: [],
      searchKey: '',
      oldSearchKey: '',
      title: '这是标题',
      date: '更新时间：2018-08-13 14:15:02',
      hasData: false // 只进行样式说明
    };
  },
  methods: {
    goToDoc: function goToDoc(docId) {
      this.getMenuList(docId);
    },
    getMenuList: function getMenuList(menuId) {
      var _this = this;

      this.axios.post('/openapi-uc/docMenu/queryDocMenuById/', {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: menuId
      }).then(function (res) {
        if (res.data.serverResult.resultCode === '200') {
          _this.$store.commit('changePageName', 'Doc');
          _this.$store.commit('changeMenuList2th', []);
          _this.$store.commit('changeMenuList3th', []);
          _this.$store.commit('changeTypeOfAppList', []);
          _this.$store.commit('changeMenuId', menuId);
          __WEBPACK_IMPORTED_MODULE_0__config_cookieUtils__["a" /* default */].set('nowMenuId', menuId);
        } else {
          _this.$message.error(res.data.serverResult.resultMessage);
        }
      });
    },

    searchDoc: function searchDoc() {
      var vm = this;
      var req = {};
      var searchKey = this.$store.state.searchKey;
      if (typeof searchKey === 'string' && searchKey.constructor === String) {
        req.searchKey = searchKey;
      } else {
        req.searchKey = this.$store.searchKey;
      }
      req.ifToText = '1';
      vm.axios.post('/openapi-uc/doc/searchDocumentView', req).then(function (response) {
        vm.oldSearchKey = req.searchKey;
        if (response.data.pageInfo && response.data.pageInfo.list && response.data.pageInfo.list.length > 0) {
          vm.documentList = response.data.pageInfo.list;
          vm.hasData = true;
          for (var a in vm.documentList) {
            var list = vm.documentList;
            if (list[a].content) {
              list[a].content = list[a].content.replace(/[/n]/g, '');
            }
            var replaceReg = new RegExp(vm.oldSearchKey, 'g'); // 匹配关键字正则
            var replaceString = "<span style='color:red'>" + vm.oldSearchKey + '</span>'; // 高亮替换v-html值
            vm.documentList[a].titleHtml = list[a].docTitle.replace(replaceReg, replaceString); // 开始替换
          }
        } else {
          vm.documentList = [];
          vm.hasData = false;
        }
      });
    }
  },
  watch: {},
  mounted: function mounted() {
    var vm = this;
    vm.searchDoc(vm.$store.state.searchKey);
  },
  created: function created() {}
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TwFindPassword',
  data: function data() {
    return {
      active: 1,
      minHeight: 0,
      type: 'phone'
    };
  },
  methods: {
    next: function next() {
      this.active++;
    }
  },
  created: function created() {
    this.minHeight = window.innerHeight - 160 + 'px';
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_plugs_particles_min_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_plugs_particles_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_plugs_particles_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    return {
      minHeight: 0,
      roleName: '学校管理员',
      options: [{
        value: 'hunan',
        label: '湖南',
        children: [{
          value: 'cs',
          label: '长沙',
          children: [{
            value: 'yuhuaqu',
            label: '雨花区'
          }]
        }]
      }, {
        value: 'zj',
        label: '浙江',
        children: [{
          value: 'hz',
          label: '杭州',
          children: [{
            value: 'jgq',
            label: '江干区'
          }]
        }]
      }]
    };
  },

  created: function created() {
    this.minHeight = window.innerHeight - 160 + 'px';
  },
  mounted: function mounted() {
    window.particlesJS.load('particles-js', '/static/dev/plugs/particles.json', function () {
      console.log('callback - particles-js config loaded');
    });
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'style',
  data: function data() {
    return {
      dialogAccess: false,
      selectedList: [],
      data: [{
        key: 1,
        lagel: '选项1'
      }, {
        key: 2,
        lagel: '选项2'
      }]
    };
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  set: function set(name, value, days) {
    var d = new Date();
    if (!days) {
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 / 2); // 默认24小时
    } else {
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    }
    window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
  },
  get: function get(name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  },
  delete: function _delete(name) {
    this.set(name, '', -1);
  }
});

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/404.169358d.png";

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(594),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6affc9fd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(560)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(589),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ad1a8cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(601),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-console",
    staticStyle: {
      "margin": "0 100px",
      "background": "#fff",
      "padding": "0 60px 60px"
    }
  }, [_c('tw-page-title', [_vm._v("图标及按钮")]), _vm._v(" "), _c('div', {
    staticClass: "twui-toolbar"
  }, [_c('a', {
    staticClass: "twui-btn xborder xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAdd = true
      }
    }
  }, [_c('i', {
    staticClass: "twui-ico xadd"
  }), _vm._v("新增")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('tw-page-title', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("弹窗")]), _vm._v(" "), _c('a', {
    staticClass: "twui-btn xborder xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAccess = true
      }
    }
  }, [_vm._v("左右选择")]), _vm._v(" "), _c('el-dialog', {
    staticClass: "twui-xmodal-base",
    attrs: {
      "title": "左右选择弹窗",
      "visible": _vm.dialogAccess,
      "size": "large",
      "close-on-click-modal": "false"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAccess = $event
      }
    }
  }, [_c('el-transfer', {
    attrs: {
      "data": _vm.data
    },
    model: {
      value: (_vm.selectedList),
      callback: function($$v) {
        _vm.selectedList = $$v
      },
      expression: "selectedList"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "twui-btn xmain xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAccess = false
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    staticClass: "twui-btn xborder xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAccess = false
      }
    }
  }, [_vm._v("取消")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xmodify"
  }), _vm._v("修改")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xdownload"
  }), _vm._v("下载")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xdel"
  }), _vm._v("删除")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico ximport"
  }), _vm._v("导入")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xlink"
  }), _vm._v("关联角色")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xvc"
  }), _vm._v("查看审核")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xconvert"
  }), _vm._v("升级脚本")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xupgrade"
  }), _vm._v("关联角色")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xlock"
  }), _vm._v("重置密码")])
}]}

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-view-box"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./editor.md/css/editormd.min.css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./css/tw-markdown-view.css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./editor.md/css/editormd.preview.min.css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "markdown-view"
    }
  }, [_c('textarea', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.doc.content))])])])
},staticRenderFns: []}

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.langOpen === 'on'),
      expression: "langOpen==='on'"
    }],
    staticClass: "twui-hovermenu"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lang === 'zh_CN'),
      expression: "lang === 'zh_CN'"
    }],
    on: {
      "click": function($event) {
        return _vm.changeLangEvent('en_US')
      }
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lang === 'en_US'),
      expression: "lang === 'en_US'"
    }],
    on: {
      "click": function($event) {
        return _vm.changeLangEvent('zh_CN')
      }
    }
  }, [_vm._v("English")])])
},staticRenderFns: []}

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-view"
  }, [_c('div', {
    staticClass: "twui-404",
    style: ({
      minHeight: _vm.minHeight
    })
  }, [_c('div', {
    staticClass: "twui-404-inner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(573)
    }
  }), _vm._v(" "), _c('p', [_vm._v("很抱歉，页面走丢了")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.backPrevPage
    }
  }, [_vm._v("返回上一个页面")]), _vm._v(" "), _c('a', [_vm._v("重新登录")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bottom",
      rawName: "v-bottom",
      value: (0),
      expression: "0"
    }]
  }, [(_vm.$store.state.MenuList2th && _vm.$store.state.MenuList2th.length > 0) ? _c('div', {
    staticClass: "twui-subnav"
  }, [_c('div', {
    staticClass: "twui-subnav-inner"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.changeMenuList3th
    },
    model: {
      value: (_vm.activeId),
      callback: function($$v) {
        _vm.activeId = $$v
      },
      expression: "activeId"
    }
  }, _vm._l((_vm.$store.state.MenuList2th), function(item) {
    return _c('el-tab-pane', {
      key: item.menuId,
      attrs: {
        "label": item.menuName,
        "name": item.menuId
      },
      on: {
        "click": function($event) {
          return _vm.changeMenuList3th(item.menuId, item.appType)
        }
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.$store.state.typeOfAppList.length > 0) ? _c('div', {
    staticClass: "xmenu"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.getAppMenuList
    },
    model: {
      value: (_vm.$store.state.activeAppId),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "activeAppId", $$v)
      },
      expression: "$store.state.activeAppId"
    }
  }, _vm._l((_vm.$store.state.typeOfAppList), function(item) {
    return _c('el-tab-pane', {
      key: item.appId,
      attrs: {
        "label": item.appName,
        "name": item.appId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.MenuList3th && _vm.$store.state.MenuList3th.length > 0) ? _c('div', {
    staticClass: "twui-body-left"
  }, [_c('el-tree', {
    staticClass: "tw-tree",
    attrs: {
      "data": _vm.$store.state.MenuList3th,
      "props": _vm.defaultTreeProps,
      "node-key": "menuId",
      "highlight-current": ""
    },
    on: {
      "node-click": _vm.changeDoc
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "twui-body-right"
  }, [_c('Editor')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-markbox xsearch xsearch-padding"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "search-result"
  }, [_c('span', {
    staticClass: "xkeywords"
  }, [_vm._v(_vm._s(_vm.oldSearchKey))]), _vm._v("\n      " + _vm._s(_vm.$t('m.common')) + _vm._s(_vm.documentList.length) + _vm._s(_vm.$t('m.ssjg')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "searchbox"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('m.input_key')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchDoc.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.$store.state.searchKey),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "searchKey", $$v)
      },
      expression: "$store.state.searchKey"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "twui-ico xsearch",
    on: {
      "click": _vm.searchDoc
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-result-box"
  }, [(_vm.hasData) ? _c('div', _vm._l((_vm.documentList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('a', {
      staticClass: "xtit",
      domProps: {
        "innerHTML": _vm._s(item.titleHtml)
      },
      on: {
        "click": function($event) {
          return _vm.goToDoc(item.docId)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "xcont"
    }, [_vm._v(_vm._s(item.content))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.hasData) ? _c('div', {
    staticClass: "nodata-box"
  }, [_c('img', {
    attrs: {
      "src": "/static/dev/images/nodata.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('m.mycxdjl')))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-editor-box"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./editor.md/css/editormd.min.css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.editorId
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-footer",
    attrs: {
      "id": "footer"
    }
  }, [_vm._t("default", function() {
    return [_vm._v("Copyright © 2008-2022 天闻数媒科技（北京）有限公司, All Rights Reserved")]
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "href": "/static/dev/images/business_licence.png",
      "target": "_blank"
    }
  }, [_vm._v("经营证照")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "twui-signup-body",
    staticStyle: {
      "{ 'min-height'": "minHeight }"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.roleName) + "注册")]), _vm._v(" "), _c('div', {
    staticClass: "twui-bgbox"
  }, [_c('div', {
    staticClass: "twui-astable xinfotip"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "twui-astable-col xinfotip-body"
  }, [_vm._v("以下是" + _vm._s(_vm.roleName) + "注册表单，每项都是必须输入项，提交注册后，将有工作人员对您的信息进行审核，审核通过后将会通过邮件通知您。")])])]), _vm._v(" "), _c('el-form', {
    staticClass: "twui-signup-form"
  }, [_c('el-form-item', {
    attrs: {
      "label": "所选地区:",
      "label-width": "7em"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择地址",
      "options": _vm.options,
      "filterable": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleName == '区域管理员'),
      expression: "roleName=='区域管理员'"
    }],
    attrs: {
      "label": "单位名称:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleName == '学校管理员'),
      expression: "roleName=='学校管理员'"
    }],
    staticClass: "twui-signup-school"
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校类型:",
      "label-width": "7em"
    }
  }, [_c('div', [_c('el-checkbox', [_vm._v("小学")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("5年制")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("6年制")])], 1), _vm._v(" "), _c('div', [_c('el-checkbox', [_vm._v("小学")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("3年制")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("4年制")])], 1), _vm._v(" "), _c('div', [_c('el-checkbox', [_vm._v("高中")]), _vm._v(" "), _c('el-radio', {
    staticClass: "twui-xspace-md"
  }, [_vm._v("3年制")])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人姓名:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录邮箱:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "twui-xspace-md",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "密码至少包含字母、数字、符号中两种，6-20个字符"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系地址:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "7em"
    }
  }, [_c('button', {
    staticClass: "twui-btn xmain xxlarge"
  }, [_vm._v("同意协议并提交")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "7em"
    }
  }, [_c('div', {
    staticClass: "twui-midline"
  }, [_c('a', {
    staticClass: "twui-midline-body twui-xlink"
  }, [_vm._v("《天闻服务协议》")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "-1",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "particles-js"
    }
  }), _vm._v(" "), _c('tw-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup-header"
  }, [_c('img', {
    attrs: {
      "src": "static/dev/images/logo_reg.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("天闻ECO云开放平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-astable-col xinfotip-imgbox"
  }, [_c('i', {
    staticClass: "twui-ico xregtip"
  })])
}]}

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "twui-header xdoc xconsole"
  }, [_c('div', {
    staticClass: "twui-header-inner",
    attrs: {
      "id": "header"
    }
  }, [_c('h1', {
    staticClass: "tw-header-left"
  }, [_c('router-link', {
    staticClass: "twui-header-logo",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.orgLogo
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tw-header-title"
  }, [_vm._v(_vm._s(_vm.$t('m.platform_name')))])], 1), _vm._v(" "), _vm._l((_vm.menuList), function(item, index) {
    return _c('div', {
      key: index,
      style: ({
        visibility: _vm.isShowMenuLis ? 'visible' : 'hidden'
      })
    }, [_c('div', {
      staticClass: "twui-header-nav"
    }, [(item.menuId === 'TWPAAS11000000003') ? _c('el-dropdown', {
      on: {
        "command": _vm.jumpTo
      }
    }, [_c('span', {
      staticClass: "xrouter"
    }, [_vm._v(_vm._s(item.menuName))]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, [_c('el-dropdown-item', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "command": "0"
      }
    }, [_vm._v(_vm._s(_vm.$t('m.twtymyapi')))]), _vm._v(" "), _c('el-dropdown-item', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "command": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('m.twzjk')))])], 1)], 1) : _c('el-button', {
      class: _vm.activeMenuId === item.menuId ? 'xactice-color' : 'xbutton-color',
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.getMenuList(item.menuId)
        }
      }
    }, [_vm._v(_vm._s(item.menuName))])], 1)])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserImg),
      expression: "showUserImg"
    }],
    staticClass: "twui-header-right"
  }, [(_vm.showDocMMneu) ? _c('el-button', {
    staticClass: "xbutton-color",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.goto
    }
  }, [_vm._v(_vm._s(_vm.$t('m.document_menu_management')))]) : _vm._e(), _vm._v(" "), _c('tw-lang', {
    ref: "twlang"
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-header-userbox xadmin"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(227),
      "alt": _vm.$t('m.yhtx')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-header-usermenu"
  }, [_c('div', {
    staticClass: "xhead"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(227),
      "alt": _vm.$t('m.yhtx')
    }
  }), _vm._v(" "), _c('span', {
    class: {
      xno: !(_vm.orgName != null && _vm.orgName != 'null' && _vm.orgName != 'undefined')
    }
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('span', {
    staticClass: "xinfo"
  }, [_vm._v(_vm._s(_vm.orgName != null && _vm.orgName != 'null' && _vm.orgName != 'undefined' ? _vm.orgName : ''))])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "twui-ico xoff"
  }), _vm._v("\n              " + _vm._s(_vm.$t('m.logout')) + "\n            ")])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showUserImg),
      expression: "!showUserImg"
    }],
    staticClass: "twui-header-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.showLogin()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('m.login')))])])], 2)]), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.hasDoc) ? _c('div', {
    staticClass: "twui-markbox",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "searchbox"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('m.input_key')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.$store.state.searchKey),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "searchKey", $$v)
      },
      expression: "$store.state.searchKey"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "twui-ico xsearch",
    on: {
      "click": _vm.toSearch
    }
  })], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.doc.docTitle))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.$t('m.update_time')) + "：" + _vm._s(_vm.doc.lastModifyTime))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [(_vm.$store.state.typeOfAppList.length === 0 && _vm.$store.state.isAdmin && !_vm.editor.isEditing) ? _c('a', {
    on: {
      "click": _vm.editorDoc
    }
  }, [_c('i', {
    staticClass: "twui-ico xedit"
  }), _vm._v("\n        " + _vm._s(_vm.$t('m.editor')) + "\n      ")]) : _c('div', {
    staticClass: "editcon"
  }, [(_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('div', {
    staticClass: "twui-ico xtips"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('m.support_file_type_info')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('el-upload', {
    staticClass: "xuploadbtn",
    attrs: {
      "action": _vm.file_upload_server,
      "headers": _vm.headerObj,
      "data": _vm.uploadData,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "before-upload": _vm.beforeUpload,
      "show-file-list": false,
      "accept": _vm.fileType
    }
  }, [_c('button', {
    staticClass: "twui-btn xborder"
  }, [_vm._v(_vm._s(_vm.$t('m.upload_file')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('button', {
    staticClass: "twui-btn xborder",
    on: {
      "click": _vm.cancelSave
    }
  }, [_vm._v(_vm._s(_vm.$t('m.cancle')))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('button', {
    staticClass: "twui-btn xmain",
    on: {
      "click": _vm.saveDoc
    }
  }, [_vm._v(_vm._s(_vm.$t('m.save')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(!_vm.editor.isEditing) ? _c('tw-markdown-view', {
    ref: "markdownView"
  }) : _vm._e(), _vm._v(" "), (_vm.editor.isEditing) ? _c('tw-markdown-editor', {
    ref: "markdown"
  }) : _vm._e()], 1)]) : _c('div', [_c('div', {
    staticClass: "nodata-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(574),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('m.zwwd')))])])])
},staticRenderFns: []}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bottom",
      rawName: "v-bottom",
      value: (0),
      expression: "0"
    }],
    staticClass: "twui-page",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "twui-doccenter xnew"
  }, [_c('tw-header', {
    on: {
      "signin": function($event) {
        _vm.dialogLogin = true
      },
      "signup": function($event) {
        _vm.dialogLoginIn = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-body"
  }, [_c('div', {
    staticClass: "twui-body-inner"
  }, [_c(_vm.$store.state.pageName, {
    tag: "component"
  })], 1)]), _vm._v(" "), _c('tw-footer'), _vm._v(" "), _c('div', {
    staticClass: "twui-rightside"
  }, [_c('tw-totop')], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "twui-login",
    attrs: {
      "title": "天闻ECO云开放平台登录",
      "visible": _vm.dialogLogin,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogLogin = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('i', {
    staticClass: "ico ico-login-user"
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入登录帐号或邮箱"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('i', {
    staticClass: "ico ico-login-pwd"
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "type": "password",
      "placeholder": "请输入密码"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('i', {
    staticClass: "ico ico-login-org"
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择机构"
    },
    model: {
      value: (_vm.org),
      callback: function($$v) {
        _vm.org = $$v
      },
      expression: "org"
    }
  }, _vm._l((_vm.orgList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "twui-login-code",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入验证码"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/dev/images/code.png"
    }
  }), _vm._v(" "), _c('a', [_vm._v("  换一换")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "twui-login-remember"
  }, [_c('el-checkbox', [_vm._v("下次自动登录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/find_password"
    }
  }, [_vm._v("忘记密码")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "twui-btn xmain xxlarge xfull",
    on: {
      "click": function($event) {
        _vm.dialogLogin = false
      }
    }
  }, [_vm._v("登录")])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "twui-loginin",
    attrs: {
      "title": "注册—请选择你的身份",
      "visible": _vm.dialogLoginIn,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogLoginIn = $event
      }
    }
  }, [_c('div', {
    staticClass: "twui-grid xpc-x5"
  }, [_c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/teacher.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是老师")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/student.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是学生")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/school.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是学校管理员")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/region.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是区域管理员")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twui-grid-col"
  }, [_c('div', {
    staticClass: "twui-loginuser"
  }, [_c('img', {
    staticClass: "twui-loginuser-img",
    attrs: {
      "src": "/static/dev/images/view/dev.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-name"
  }, [_vm._v("我是应用开发者")]), _vm._v(" "), _c('div', {
    staticClass: "twui-loginuser-footer"
  }, [_c('router-link', {
    staticClass: "twui-btn xborder xlarge",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")])], 1)])])])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu-item-set"
  }, [_vm._v(_vm._s(_vm.$t('m.cdlmsz')))]), _vm._v(" "), _c('div', {
    staticClass: "xtable"
  }, [_c('div', {
    staticClass: "twui-body-left"
  }, [_c('el-tree', {
    key: "dev-tree",
    ref: "tree",
    staticClass: "tw-tree xsmall",
    attrs: {
      "node-key": "id",
      "highlight-current": "",
      "data": _vm.devTreeData,
      "props": _vm.devTreeDefaultProps,
      "indent": 8,
      "default-expanded-keys": _vm.devTreeExpandedKeys,
      "expand-on-click-node": false
    },
    on: {
      "node-click": _vm.setMenuInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "twui-body-space"
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-body-right"
  }, [_c('div', {
    staticClass: "xpadding-menuchange"
  }, [(!_vm.newflag) ? _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.menuName'),
      "prop": "menuName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.canSave
    },
    model: {
      value: (_vm.ruleForm.menuName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "menuName", $$v)
      },
      expression: "ruleForm.menuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.superior'),
      "prop": "region"
    }
  }, [_c('el-select', {
    staticClass: "xselect-width",
    attrs: {
      "disabled": !_vm.canSave,
      "placeholder": _vm.$t('m.selectTop')
    },
    model: {
      value: (_vm.ruleForm.parentMenuId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "parentMenuId", $$v)
      },
      expression: "ruleForm.parentMenuId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('m.nothing'),
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.devTreeData), function(item) {
    return _c('el-option', {
      key: item.menuId,
      attrs: {
        "label": item.menuName,
        "value": item.menuId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.sortNum'),
      "prop": "sortNum"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.canSave
    },
    model: {
      value: (_vm.ruleForm.sortNum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sortNum", $$v)
      },
      expression: "ruleForm.sortNum"
    }
  })], 1), _vm._v(" "), (_vm.canSave) ? _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', [_vm._v(_vm._s(_vm.$t('m.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateDocMenu
    }
  }, [_vm._v(_vm._s(_vm.$t('m.save')))])], 1) : _vm._e()], 1) : _c('el-form', {
    ref: "newForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.menuName'),
      "prop": "menuName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newForm.menuName),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "menuName", $$v)
      },
      expression: "newForm.menuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.superior'),
      "prop": "region"
    }
  }, [_c('el-select', {
    staticClass: "xselect-width",
    attrs: {
      "placeholder": _vm.$t('m.selectTop'),
      "disabled": ""
    },
    model: {
      value: (_vm.newForm.region),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "region", $$v)
      },
      expression: "newForm.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('m.nothing'),
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.devTreeData), function(item) {
    return _c('el-option', {
      key: item.menuId,
      attrs: {
        "label": item.menuName,
        "value": item.menuId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.sortNum'),
      "prop": "sortNum"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newForm.sortNum),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "sortNum", $$v)
      },
      expression: "newForm.sortNum"
    }
  })], 1), _vm._v(" "), (_vm.newflag) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('m.appType'),
      "prop": "appType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.newForm.appType),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "appType", $$v)
      },
      expression: "newForm.appType"
    }
  }, _vm._l((_vm.appTypes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.newflag = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('m.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDocument
    }
  }, [_vm._v(_vm._s(_vm.$t('m.add')))])], 1)], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup xfind"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "twui-signup-body",
    style: ({
      'min-height': _vm.minHeight
    })
  }, [_c('h2', [_vm._v("找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "twui-steps xfind"
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('el-step', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "title": "填写帐户名"
    }
  }), _vm._v(" "), _c('el-step', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "title": "验证身份"
    }
  }), _vm._v(" "), _c('el-step', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "title": "设置新密码"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "完成"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 1),
      expression: "active==1"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("填写帐户名")]), _vm._v(" "), _c('el-form', {
    staticClass: "twui-findpwd"
  }, [_c('el-form-item', {
    attrs: {
      "label": "帐户名:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/dev/images/code.png"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择验证身份方式:",
      "label-width": "11em"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "phone"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("手机验证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "email"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("邮箱验证")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 2),
      expression: "active==2"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("验证身份")]), _vm._v(" "), (_vm.type === 'phone') ? _c('el-form', {
    staticClass: "twui-findpwd"
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "label-width": "11em"
    }
  }, [_vm._v("用户姓名")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已验证手机:",
      "label-width": "11em"
    }
  }, [_vm._v("137****143")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请填写手机验证码:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('el-form', {
    staticClass: "twui-findpwd"
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "label-width": "11em"
    }
  }, [_vm._v("用户姓名")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱:",
      "label-width": "11em"
    }
  }, [_vm._v("137****143")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请填写邮箱验证码:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 3),
      expression: "active==3"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("设置新密码")]), _vm._v(" "), _c('el-form', {
    staticClass: "twui-findpwd",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新登录密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 4),
      expression: "active==4"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("完成")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "left"
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("请牢记您新设置的密码,"), _c('router-link', {
    staticClass: "twui-xlink",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("返回首页")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "twui-btnarea"
  }, [_c('div', {
    staticClass: "twui-btnarea-inner"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active < 3),
      expression: "active<3"
    }],
    staticClass: "twui-btn xmain xlarge xdisabled",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active === 3),
      expression: "active===3"
    }],
    staticClass: "twui-btn xmain xlarge",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("提交")])])])]), _vm._v(" "), _c('tw-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup-header"
  }, [_c('img', {
    attrs: {
      "src": "static/dev/images/logo_reg.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "twui-xhighlight3"
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("  新密码设置成功!")])
}]}

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "x-mt-tiny xtotop",
    class: {
      xactive: _vm.visible
    },
    on: {
      "click": _vm.toTopHandler
    }
  }, [_c('i', {
    staticClass: "twui-ico xtotop"
  }), _c('span', [_vm._v("返回顶部")])])
},staticRenderFns: []}

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

/* -----------------------------------------------
/* Author : Vincent Garreau  - vincentgarreau.com
/* MIT license: http://opensource.org/licenses/MIT
/* Demo / Generator : vincentgarreau.com/particles.js
/* GitHub : github.com/VincentGarreau/particles.js
/* How to use? : Check the GitHub README
/* v2.0.0
/* ----------------------------------------------- */
function hexToRgb(e){var a=/^#?([a-f\d])([a-f\d])([a-f\d])$/i;e=e.replace(a,function(e,a,t,i){return a+a+t+t+i+i});var t=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);return t?{r:parseInt(t[1],16),g:parseInt(t[2],16),b:parseInt(t[3],16)}:null}function clamp(e,a,t){return Math.min(Math.max(e,a),t)}function isInArray(e,a){return a.indexOf(e)>-1}var pJS=function(e,a){var t=document.querySelector("#"+e+" > .particles-js-canvas-el");this.pJS={canvas:{el:t,w:t.offsetWidth,h:t.offsetHeight},particles:{number:{value:400,density:{enable:!0,value_area:800}},color:{value:"#fff"},shape:{type:"circle",stroke:{width:0,color:"#ff0000"},polygon:{nb_sides:5},image:{src:"",width:100,height:100}},opacity:{value:1,random:!1,anim:{enable:!1,speed:2,opacity_min:0,sync:!1}},size:{value:20,random:!1,anim:{enable:!1,speed:20,size_min:0,sync:!1}},line_linked:{enable:!0,distance:100,color:"#fff",opacity:1,width:1},move:{enable:!0,speed:2,direction:"none",random:!1,straight:!1,out_mode:"out",bounce:!1,attract:{enable:!1,rotateX:3e3,rotateY:3e3}},array:[]},interactivity:{detect_on:"canvas",events:{onhover:{enable:!0,mode:"grab"},onclick:{enable:!0,mode:"push"},resize:!0},modes:{grab:{distance:100,line_linked:{opacity:1}},bubble:{distance:200,size:80,duration:.4},repulse:{distance:200,duration:.4},push:{particles_nb:4},remove:{particles_nb:2}},mouse:{}},retina_detect:!1,fn:{interact:{},modes:{},vendors:{}},tmp:{}};var i=this.pJS;a&&Object.deepExtend(i,a),i.tmp.obj={size_value:i.particles.size.value,size_anim_speed:i.particles.size.anim.speed,move_speed:i.particles.move.speed,line_linked_distance:i.particles.line_linked.distance,line_linked_width:i.particles.line_linked.width,mode_grab_distance:i.interactivity.modes.grab.distance,mode_bubble_distance:i.interactivity.modes.bubble.distance,mode_bubble_size:i.interactivity.modes.bubble.size,mode_repulse_distance:i.interactivity.modes.repulse.distance},i.fn.retinaInit=function(){i.retina_detect&&window.devicePixelRatio>1?(i.canvas.pxratio=window.devicePixelRatio,i.tmp.retina=!0):(i.canvas.pxratio=1,i.tmp.retina=!1),i.canvas.w=i.canvas.el.offsetWidth*i.canvas.pxratio,i.canvas.h=i.canvas.el.offsetHeight*i.canvas.pxratio,i.particles.size.value=i.tmp.obj.size_value*i.canvas.pxratio,i.particles.size.anim.speed=i.tmp.obj.size_anim_speed*i.canvas.pxratio,i.particles.move.speed=i.tmp.obj.move_speed*i.canvas.pxratio,i.particles.line_linked.distance=i.tmp.obj.line_linked_distance*i.canvas.pxratio,i.interactivity.modes.grab.distance=i.tmp.obj.mode_grab_distance*i.canvas.pxratio,i.interactivity.modes.bubble.distance=i.tmp.obj.mode_bubble_distance*i.canvas.pxratio,i.particles.line_linked.width=i.tmp.obj.line_linked_width*i.canvas.pxratio,i.interactivity.modes.bubble.size=i.tmp.obj.mode_bubble_size*i.canvas.pxratio,i.interactivity.modes.repulse.distance=i.tmp.obj.mode_repulse_distance*i.canvas.pxratio},i.fn.canvasInit=function(){i.canvas.ctx=i.canvas.el.getContext("2d")},i.fn.canvasSize=function(){i.canvas.el.width=i.canvas.w,i.canvas.el.height=i.canvas.h,i&&i.interactivity.events.resize&&window.addEventListener("resize",function(){i.canvas.w=i.canvas.el.offsetWidth,i.canvas.h=i.canvas.el.offsetHeight,i.tmp.retina&&(i.canvas.w*=i.canvas.pxratio,i.canvas.h*=i.canvas.pxratio),i.canvas.el.width=i.canvas.w,i.canvas.el.height=i.canvas.h,i.particles.move.enable||(i.fn.particlesEmpty(),i.fn.particlesCreate(),i.fn.particlesDraw(),i.fn.vendors.densityAutoParticles()),i.fn.vendors.densityAutoParticles()})},i.fn.canvasPaint=function(){i.canvas.ctx.fillRect(0,0,i.canvas.w,i.canvas.h)},i.fn.canvasClear=function(){i.canvas.ctx.clearRect(0,0,i.canvas.w,i.canvas.h)},i.fn.particle=function(e,a,t){if(this.radius=(i.particles.size.random?Math.random():1)*i.particles.size.value,i.particles.size.anim.enable&&(this.size_status=!1,this.vs=i.particles.size.anim.speed/100,i.particles.size.anim.sync||(this.vs=this.vs*Math.random())),this.x=t?t.x:Math.random()*i.canvas.w,this.y=t?t.y:Math.random()*i.canvas.h,this.x>i.canvas.w-2*this.radius?this.x=this.x-this.radius:this.x<2*this.radius&&(this.x=this.x+this.radius),this.y>i.canvas.h-2*this.radius?this.y=this.y-this.radius:this.y<2*this.radius&&(this.y=this.y+this.radius),i.particles.move.bounce&&i.fn.vendors.checkOverlap(this,t),this.color={},"object"==typeof e.value)if(e.value instanceof Array){var s=e.value[Math.floor(Math.random()*i.particles.color.value.length)];this.color.rgb=hexToRgb(s)}else void 0!=e.value.r&&void 0!=e.value.g&&void 0!=e.value.b&&(this.color.rgb={r:e.value.r,g:e.value.g,b:e.value.b}),void 0!=e.value.h&&void 0!=e.value.s&&void 0!=e.value.l&&(this.color.hsl={h:e.value.h,s:e.value.s,l:e.value.l});else"random"==e.value?this.color.rgb={r:Math.floor(256*Math.random())+0,g:Math.floor(256*Math.random())+0,b:Math.floor(256*Math.random())+0}:"string"==typeof e.value&&(this.color=e,this.color.rgb=hexToRgb(this.color.value));this.opacity=(i.particles.opacity.random?Math.random():1)*i.particles.opacity.value,i.particles.opacity.anim.enable&&(this.opacity_status=!1,this.vo=i.particles.opacity.anim.speed/100,i.particles.opacity.anim.sync||(this.vo=this.vo*Math.random()));var n={};switch(i.particles.move.direction){case"top":n={x:0,y:-1};break;case"top-right":n={x:.5,y:-.5};break;case"right":n={x:1,y:-0};break;case"bottom-right":n={x:.5,y:.5};break;case"bottom":n={x:0,y:1};break;case"bottom-left":n={x:-.5,y:1};break;case"left":n={x:-1,y:0};break;case"top-left":n={x:-.5,y:-.5};break;default:n={x:0,y:0}}i.particles.move.straight?(this.vx=n.x,this.vy=n.y,i.particles.move.random&&(this.vx=this.vx*Math.random(),this.vy=this.vy*Math.random())):(this.vx=n.x+Math.random()-.5,this.vy=n.y+Math.random()-.5),this.vx_i=this.vx,this.vy_i=this.vy;var r=i.particles.shape.type;if("object"==typeof r){if(r instanceof Array){var c=r[Math.floor(Math.random()*r.length)];this.shape=c}}else this.shape=r;if("image"==this.shape){var o=i.particles.shape;this.img={src:o.image.src,ratio:o.image.width/o.image.height},this.img.ratio||(this.img.ratio=1),"svg"==i.tmp.img_type&&void 0!=i.tmp.source_svg&&(i.fn.vendors.createSvgImg(this),i.tmp.pushing&&(this.img.loaded=!1))}},i.fn.particle.prototype.draw=function(){function e(){i.canvas.ctx.drawImage(r,a.x-t,a.y-t,2*t,2*t/a.img.ratio)}var a=this;if(void 0!=a.radius_bubble)var t=a.radius_bubble;else var t=a.radius;if(void 0!=a.opacity_bubble)var s=a.opacity_bubble;else var s=a.opacity;if(a.color.rgb)var n="rgba("+a.color.rgb.r+","+a.color.rgb.g+","+a.color.rgb.b+","+s+")";else var n="hsla("+a.color.hsl.h+","+a.color.hsl.s+"%,"+a.color.hsl.l+"%,"+s+")";switch(i.canvas.ctx.fillStyle=n,i.canvas.ctx.beginPath(),a.shape){case"circle":i.canvas.ctx.arc(a.x,a.y,t,0,2*Math.PI,!1);break;case"edge":i.canvas.ctx.rect(a.x-t,a.y-t,2*t,2*t);break;case"triangle":i.fn.vendors.drawShape(i.canvas.ctx,a.x-t,a.y+t/1.66,2*t,3,2);break;case"polygon":i.fn.vendors.drawShape(i.canvas.ctx,a.x-t/(i.particles.shape.polygon.nb_sides/3.5),a.y-t/.76,2.66*t/(i.particles.shape.polygon.nb_sides/3),i.particles.shape.polygon.nb_sides,1);break;case"star":i.fn.vendors.drawShape(i.canvas.ctx,a.x-2*t/(i.particles.shape.polygon.nb_sides/4),a.y-t/1.52,2*t*2.66/(i.particles.shape.polygon.nb_sides/3),i.particles.shape.polygon.nb_sides,2);break;case"image":if("svg"==i.tmp.img_type)var r=a.img.obj;else var r=i.tmp.img_obj;r&&e()}i.canvas.ctx.closePath(),i.particles.shape.stroke.width>0&&(i.canvas.ctx.strokeStyle=i.particles.shape.stroke.color,i.canvas.ctx.lineWidth=i.particles.shape.stroke.width,i.canvas.ctx.stroke()),i.canvas.ctx.fill()},i.fn.particlesCreate=function(){for(var e=0;e<i.particles.number.value;e++)i.particles.array.push(new i.fn.particle(i.particles.color,i.particles.opacity.value))},i.fn.particlesUpdate=function(){for(var e=0;e<i.particles.array.length;e++){var a=i.particles.array[e];if(i.particles.move.enable){var t=i.particles.move.speed/2;a.x+=a.vx*t,a.y+=a.vy*t}if(i.particles.opacity.anim.enable&&(1==a.opacity_status?(a.opacity>=i.particles.opacity.value&&(a.opacity_status=!1),a.opacity+=a.vo):(a.opacity<=i.particles.opacity.anim.opacity_min&&(a.opacity_status=!0),a.opacity-=a.vo),a.opacity<0&&(a.opacity=0)),i.particles.size.anim.enable&&(1==a.size_status?(a.radius>=i.particles.size.value&&(a.size_status=!1),a.radius+=a.vs):(a.radius<=i.particles.size.anim.size_min&&(a.size_status=!0),a.radius-=a.vs),a.radius<0&&(a.radius=0)),"bounce"==i.particles.move.out_mode)var s={x_left:a.radius,x_right:i.canvas.w,y_top:a.radius,y_bottom:i.canvas.h};else var s={x_left:-a.radius,x_right:i.canvas.w+a.radius,y_top:-a.radius,y_bottom:i.canvas.h+a.radius};switch(a.x-a.radius>i.canvas.w?(a.x=s.x_left,a.y=Math.random()*i.canvas.h):a.x+a.radius<0&&(a.x=s.x_right,a.y=Math.random()*i.canvas.h),a.y-a.radius>i.canvas.h?(a.y=s.y_top,a.x=Math.random()*i.canvas.w):a.y+a.radius<0&&(a.y=s.y_bottom,a.x=Math.random()*i.canvas.w),i.particles.move.out_mode){case"bounce":a.x+a.radius>i.canvas.w?a.vx=-a.vx:a.x-a.radius<0&&(a.vx=-a.vx),a.y+a.radius>i.canvas.h?a.vy=-a.vy:a.y-a.radius<0&&(a.vy=-a.vy)}if(isInArray("grab",i.interactivity.events.onhover.mode)&&i.fn.modes.grabParticle(a),(isInArray("bubble",i.interactivity.events.onhover.mode)||isInArray("bubble",i.interactivity.events.onclick.mode))&&i.fn.modes.bubbleParticle(a),(isInArray("repulse",i.interactivity.events.onhover.mode)||isInArray("repulse",i.interactivity.events.onclick.mode))&&i.fn.modes.repulseParticle(a),i.particles.line_linked.enable||i.particles.move.attract.enable)for(var n=e+1;n<i.particles.array.length;n++){var r=i.particles.array[n];i.particles.line_linked.enable&&i.fn.interact.linkParticles(a,r),i.particles.move.attract.enable&&i.fn.interact.attractParticles(a,r),i.particles.move.bounce&&i.fn.interact.bounceParticles(a,r)}}},i.fn.particlesDraw=function(){i.canvas.ctx.clearRect(0,0,i.canvas.w,i.canvas.h),i.fn.particlesUpdate();for(var e=0;e<i.particles.array.length;e++){var a=i.particles.array[e];a.draw()}},i.fn.particlesEmpty=function(){i.particles.array=[]},i.fn.particlesRefresh=function(){cancelRequestAnimFrame(i.fn.checkAnimFrame),cancelRequestAnimFrame(i.fn.drawAnimFrame),i.tmp.source_svg=void 0,i.tmp.img_obj=void 0,i.tmp.count_svg=0,i.fn.particlesEmpty(),i.fn.canvasClear(),i.fn.vendors.start()},i.fn.interact.linkParticles=function(e,a){var t=e.x-a.x,s=e.y-a.y,n=Math.sqrt(t*t+s*s);if(n<=i.particles.line_linked.distance){var r=i.particles.line_linked.opacity-n/(1/i.particles.line_linked.opacity)/i.particles.line_linked.distance;if(r>0){var c=i.particles.line_linked.color_rgb_line;i.canvas.ctx.strokeStyle="rgba("+c.r+","+c.g+","+c.b+","+r+")",i.canvas.ctx.lineWidth=i.particles.line_linked.width,i.canvas.ctx.beginPath(),i.canvas.ctx.moveTo(e.x,e.y),i.canvas.ctx.lineTo(a.x,a.y),i.canvas.ctx.stroke(),i.canvas.ctx.closePath()}}},i.fn.interact.attractParticles=function(e,a){var t=e.x-a.x,s=e.y-a.y,n=Math.sqrt(t*t+s*s);if(n<=i.particles.line_linked.distance){var r=t/(1e3*i.particles.move.attract.rotateX),c=s/(1e3*i.particles.move.attract.rotateY);e.vx-=r,e.vy-=c,a.vx+=r,a.vy+=c}},i.fn.interact.bounceParticles=function(e,a){var t=e.x-a.x,i=e.y-a.y,s=Math.sqrt(t*t+i*i),n=e.radius+a.radius;n>=s&&(e.vx=-e.vx,e.vy=-e.vy,a.vx=-a.vx,a.vy=-a.vy)},i.fn.modes.pushParticles=function(e,a){i.tmp.pushing=!0;for(var t=0;e>t;t++)i.particles.array.push(new i.fn.particle(i.particles.color,i.particles.opacity.value,{x:a?a.pos_x:Math.random()*i.canvas.w,y:a?a.pos_y:Math.random()*i.canvas.h})),t==e-1&&(i.particles.move.enable||i.fn.particlesDraw(),i.tmp.pushing=!1)},i.fn.modes.removeParticles=function(e){i.particles.array.splice(0,e),i.particles.move.enable||i.fn.particlesDraw()},i.fn.modes.bubbleParticle=function(e){function a(){e.opacity_bubble=e.opacity,e.radius_bubble=e.radius}function t(a,t,s,n,c){if(a!=t)if(i.tmp.bubble_duration_end){if(void 0!=s){var o=n-p*(n-a)/i.interactivity.modes.bubble.duration,l=a-o;d=a+l,"size"==c&&(e.radius_bubble=d),"opacity"==c&&(e.opacity_bubble=d)}}else if(r<=i.interactivity.modes.bubble.distance){if(void 0!=s)var v=s;else var v=n;if(v!=a){var d=n-p*(n-a)/i.interactivity.modes.bubble.duration;"size"==c&&(e.radius_bubble=d),"opacity"==c&&(e.opacity_bubble=d)}}else"size"==c&&(e.radius_bubble=void 0),"opacity"==c&&(e.opacity_bubble=void 0)}if(i.interactivity.events.onhover.enable&&isInArray("bubble",i.interactivity.events.onhover.mode)){var s=e.x-i.interactivity.mouse.pos_x,n=e.y-i.interactivity.mouse.pos_y,r=Math.sqrt(s*s+n*n),c=1-r/i.interactivity.modes.bubble.distance;if(r<=i.interactivity.modes.bubble.distance){if(c>=0&&"mousemove"==i.interactivity.status){if(i.interactivity.modes.bubble.size!=i.particles.size.value)if(i.interactivity.modes.bubble.size>i.particles.size.value){var o=e.radius+i.interactivity.modes.bubble.size*c;o>=0&&(e.radius_bubble=o)}else{var l=e.radius-i.interactivity.modes.bubble.size,o=e.radius-l*c;o>0?e.radius_bubble=o:e.radius_bubble=0}if(i.interactivity.modes.bubble.opacity!=i.particles.opacity.value)if(i.interactivity.modes.bubble.opacity>i.particles.opacity.value){var v=i.interactivity.modes.bubble.opacity*c;v>e.opacity&&v<=i.interactivity.modes.bubble.opacity&&(e.opacity_bubble=v)}else{var v=e.opacity-(i.particles.opacity.value-i.interactivity.modes.bubble.opacity)*c;v<e.opacity&&v>=i.interactivity.modes.bubble.opacity&&(e.opacity_bubble=v)}}}else a();"mouseleave"==i.interactivity.status&&a()}else if(i.interactivity.events.onclick.enable&&isInArray("bubble",i.interactivity.events.onclick.mode)){if(i.tmp.bubble_clicking){var s=e.x-i.interactivity.mouse.click_pos_x,n=e.y-i.interactivity.mouse.click_pos_y,r=Math.sqrt(s*s+n*n),p=((new Date).getTime()-i.interactivity.mouse.click_time)/1e3;p>i.interactivity.modes.bubble.duration&&(i.tmp.bubble_duration_end=!0),p>2*i.interactivity.modes.bubble.duration&&(i.tmp.bubble_clicking=!1,i.tmp.bubble_duration_end=!1)}i.tmp.bubble_clicking&&(t(i.interactivity.modes.bubble.size,i.particles.size.value,e.radius_bubble,e.radius,"size"),t(i.interactivity.modes.bubble.opacity,i.particles.opacity.value,e.opacity_bubble,e.opacity,"opacity"))}},i.fn.modes.repulseParticle=function(e){function a(){var a=Math.atan2(d,p);if(e.vx=u*Math.cos(a),e.vy=u*Math.sin(a),"bounce"==i.particles.move.out_mode){var t={x:e.x+e.vx,y:e.y+e.vy};t.x+e.radius>i.canvas.w?e.vx=-e.vx:t.x-e.radius<0&&(e.vx=-e.vx),t.y+e.radius>i.canvas.h?e.vy=-e.vy:t.y-e.radius<0&&(e.vy=-e.vy)}}if(i.interactivity.events.onhover.enable&&isInArray("repulse",i.interactivity.events.onhover.mode)&&"mousemove"==i.interactivity.status){var t=e.x-i.interactivity.mouse.pos_x,s=e.y-i.interactivity.mouse.pos_y,n=Math.sqrt(t*t+s*s),r={x:t/n,y:s/n},c=i.interactivity.modes.repulse.distance,o=100,l=clamp(1/c*(-1*Math.pow(n/c,2)+1)*c*o,0,50),v={x:e.x+r.x*l,y:e.y+r.y*l};"bounce"==i.particles.move.out_mode?(v.x-e.radius>0&&v.x+e.radius<i.canvas.w&&(e.x=v.x),v.y-e.radius>0&&v.y+e.radius<i.canvas.h&&(e.y=v.y)):(e.x=v.x,e.y=v.y)}else if(i.interactivity.events.onclick.enable&&isInArray("repulse",i.interactivity.events.onclick.mode))if(i.tmp.repulse_finish||(i.tmp.repulse_count++,i.tmp.repulse_count==i.particles.array.length&&(i.tmp.repulse_finish=!0)),i.tmp.repulse_clicking){var c=Math.pow(i.interactivity.modes.repulse.distance/6,3),p=i.interactivity.mouse.click_pos_x-e.x,d=i.interactivity.mouse.click_pos_y-e.y,m=p*p+d*d,u=-c/m*1;c>=m&&a()}else 0==i.tmp.repulse_clicking&&(e.vx=e.vx_i,e.vy=e.vy_i)},i.fn.modes.grabParticle=function(e){if(i.interactivity.events.onhover.enable&&"mousemove"==i.interactivity.status){var a=e.x-i.interactivity.mouse.pos_x,t=e.y-i.interactivity.mouse.pos_y,s=Math.sqrt(a*a+t*t);if(s<=i.interactivity.modes.grab.distance){var n=i.interactivity.modes.grab.line_linked.opacity-s/(1/i.interactivity.modes.grab.line_linked.opacity)/i.interactivity.modes.grab.distance;if(n>0){var r=i.particles.line_linked.color_rgb_line;i.canvas.ctx.strokeStyle="rgba("+r.r+","+r.g+","+r.b+","+n+")",i.canvas.ctx.lineWidth=i.particles.line_linked.width,i.canvas.ctx.beginPath(),i.canvas.ctx.moveTo(e.x,e.y),i.canvas.ctx.lineTo(i.interactivity.mouse.pos_x,i.interactivity.mouse.pos_y),i.canvas.ctx.stroke(),i.canvas.ctx.closePath()}}}},i.fn.vendors.eventsListeners=function(){"window"==i.interactivity.detect_on?i.interactivity.el=window:i.interactivity.el=i.canvas.el,(i.interactivity.events.onhover.enable||i.interactivity.events.onclick.enable)&&(i.interactivity.el.addEventListener("mousemove",function(e){if(i.interactivity.el==window)var a=e.clientX,t=e.clientY;else var a=e.offsetX||e.clientX,t=e.offsetY||e.clientY;i.interactivity.mouse.pos_x=a,i.interactivity.mouse.pos_y=t,i.tmp.retina&&(i.interactivity.mouse.pos_x*=i.canvas.pxratio,i.interactivity.mouse.pos_y*=i.canvas.pxratio),i.interactivity.status="mousemove"}),i.interactivity.el.addEventListener("mouseleave",function(e){i.interactivity.mouse.pos_x=null,i.interactivity.mouse.pos_y=null,i.interactivity.status="mouseleave"})),i.interactivity.events.onclick.enable&&i.interactivity.el.addEventListener("click",function(){if(i.interactivity.mouse.click_pos_x=i.interactivity.mouse.pos_x,i.interactivity.mouse.click_pos_y=i.interactivity.mouse.pos_y,i.interactivity.mouse.click_time=(new Date).getTime(),i.interactivity.events.onclick.enable)switch(i.interactivity.events.onclick.mode){case"push":i.particles.move.enable?i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb,i.interactivity.mouse):1==i.interactivity.modes.push.particles_nb?i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb,i.interactivity.mouse):i.interactivity.modes.push.particles_nb>1&&i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb);break;case"remove":i.fn.modes.removeParticles(i.interactivity.modes.remove.particles_nb);break;case"bubble":i.tmp.bubble_clicking=!0;break;case"repulse":i.tmp.repulse_clicking=!0,i.tmp.repulse_count=0,i.tmp.repulse_finish=!1,setTimeout(function(){i.tmp.repulse_clicking=!1},1e3*i.interactivity.modes.repulse.duration)}})},i.fn.vendors.densityAutoParticles=function(){if(i.particles.number.density.enable){var e=i.canvas.el.width*i.canvas.el.height/1e3;i.tmp.retina&&(e/=2*i.canvas.pxratio);var a=e*i.particles.number.value/i.particles.number.density.value_area,t=i.particles.array.length-a;0>t?i.fn.modes.pushParticles(Math.abs(t)):i.fn.modes.removeParticles(t)}},i.fn.vendors.checkOverlap=function(e,a){for(var t=0;t<i.particles.array.length;t++){var s=i.particles.array[t],n=e.x-s.x,r=e.y-s.y,c=Math.sqrt(n*n+r*r);c<=e.radius+s.radius&&(e.x=a?a.x:Math.random()*i.canvas.w,e.y=a?a.y:Math.random()*i.canvas.h,i.fn.vendors.checkOverlap(e))}},i.fn.vendors.createSvgImg=function(e){var a=i.tmp.source_svg,t=/#([0-9A-F]{3,6})/gi,s=a.replace(t,function(a,t,i,s){if(e.color.rgb)var n="rgba("+e.color.rgb.r+","+e.color.rgb.g+","+e.color.rgb.b+","+e.opacity+")";else var n="hsla("+e.color.hsl.h+","+e.color.hsl.s+"%,"+e.color.hsl.l+"%,"+e.opacity+")";return n}),n=new Blob([s],{type:"image/svg+xml;charset=utf-8"}),r=window.URL||window.webkitURL||window,c=r.createObjectURL(n),o=new Image;o.addEventListener("load",function(){e.img.obj=o,e.img.loaded=!0,r.revokeObjectURL(c),i.tmp.count_svg++}),o.src=c},i.fn.vendors.destroypJS=function(){cancelAnimationFrame(i.fn.drawAnimFrame),t.remove(),pJSDom=null},i.fn.vendors.drawShape=function(e,a,t,i,s,n){var r=s*n,c=s/n,o=180*(c-2)/c,l=Math.PI-Math.PI*o/180;e.save(),e.beginPath(),e.translate(a,t),e.moveTo(0,0);for(var v=0;r>v;v++)e.lineTo(i,0),e.translate(i,0),e.rotate(l);e.fill(),e.restore()},i.fn.vendors.exportImg=function(){window.open(i.canvas.el.toDataURL("image/png"),"_blank")},i.fn.vendors.loadImg=function(e){if(i.tmp.img_error=void 0,""!=i.particles.shape.image.src)if("svg"==e){var a=new XMLHttpRequest;a.open("GET",i.particles.shape.image.src),a.onreadystatechange=function(e){4==a.readyState&&(200==a.status?(i.tmp.source_svg=e.currentTarget.response,i.fn.vendors.checkBeforeDraw()):(console.log("Error pJS - Image not found"),i.tmp.img_error=!0))},a.send()}else{var t=new Image;t.addEventListener("load",function(){i.tmp.img_obj=t,i.fn.vendors.checkBeforeDraw()}),t.src=i.particles.shape.image.src}else console.log("Error pJS - No image.src"),i.tmp.img_error=!0},i.fn.vendors.draw=function(){"image"==i.particles.shape.type?"svg"==i.tmp.img_type?i.tmp.count_svg>=i.particles.number.value?(i.fn.particlesDraw(),i.particles.move.enable?i.fn.drawAnimFrame=requestAnimFrame(i.fn.vendors.draw):cancelRequestAnimFrame(i.fn.drawAnimFrame)):i.tmp.img_error||(i.fn.drawAnimFrame=requestAnimFrame(i.fn.vendors.draw)):void 0!=i.tmp.img_obj?(i.fn.particlesDraw(),i.particles.move.enable?i.fn.drawAnimFrame=requestAnimFrame(i.fn.vendors.draw):cancelRequestAnimFrame(i.fn.drawAnimFrame)):i.tmp.img_error||(i.fn.drawAnimFrame=requestAnimFrame(i.fn.vendors.draw)):(i.fn.particlesDraw(),i.particles.move.enable?i.fn.drawAnimFrame=requestAnimFrame(i.fn.vendors.draw):cancelRequestAnimFrame(i.fn.drawAnimFrame))},i.fn.vendors.checkBeforeDraw=function(){"image"==i.particles.shape.type?"svg"==i.tmp.img_type&&void 0==i.tmp.source_svg?i.tmp.checkAnimFrame=requestAnimFrame(check):(cancelRequestAnimFrame(i.tmp.checkAnimFrame),i.tmp.img_error||(i.fn.vendors.init(),i.fn.vendors.draw())):(i.fn.vendors.init(),i.fn.vendors.draw())},i.fn.vendors.init=function(){i.fn.retinaInit(),i.fn.canvasInit(),i.fn.canvasSize(),i.fn.canvasPaint(),i.fn.particlesCreate(),i.fn.vendors.densityAutoParticles(),i.particles.line_linked.color_rgb_line=hexToRgb(i.particles.line_linked.color)},i.fn.vendors.start=function(){isInArray("image",i.particles.shape.type)?(i.tmp.img_type=i.particles.shape.image.src.substr(i.particles.shape.image.src.length-3),i.fn.vendors.loadImg(i.tmp.img_type)):i.fn.vendors.checkBeforeDraw()},i.fn.vendors.eventsListeners(),i.fn.vendors.start()};Object.deepExtend=function(e,a){for(var t in a)a[t]&&a[t].constructor&&a[t].constructor===Object?(e[t]=e[t]||{},arguments.callee(e[t],a[t])):e[t]=a[t];return e},window.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e){window.setTimeout(e,1e3/60)}}(),window.cancelRequestAnimFrame=function(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.mozCancelRequestAnimationFrame||window.oCancelRequestAnimationFrame||window.msCancelRequestAnimationFrame||clearTimeout}(),window.pJSDom=[],window.particlesJS=function(e,a){"string"!=typeof e&&(a=e,e="particles-js"),e||(e="particles-js");var t=document.getElementById(e),i="particles-js-canvas-el",s=t.getElementsByClassName(i);if(s.length)for(;s.length>0;)t.removeChild(s[0]);var n=document.createElement("canvas");n.className=i,n.style.width="100%",n.style.height="100%";var r=document.getElementById(e).appendChild(n);null!=r&&pJSDom.push(new pJS(e,a))},window.particlesJS.load=function(e,a,t){var i=new XMLHttpRequest;i.open("GET",a),i.onreadystatechange=function(a){if(4==i.readyState)if(200==i.status){var s=JSON.parse(a.currentTarget.response);window.particlesJS(e,s),t&&t()}else console.log("Error pJS - XMLHttpRequest status: "+i.status),console.log("Error pJS - File config not found")},i.send()};

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
module.exports = __webpack_require__(232);


/***/ })

},[607]);


// WEBPACK FOOTER //
// js/app.b5b576b8bae80e161b7d.js